export default {
  locale: 'ja',
  messages: {
	accountMy: 'マイアカウント',
	actions: '操作',
	add: '追加',
	addressAddNew: '新しい住所を追加',
	addressCity: '市区町村',
	addressCountries: '国',
	addressCountry: '国',
	addressDeleteConfirmTitle: '住所の削除',
	addressDeleteConfirmMessage: 'この住所を削除してもよろしいですか？',
	addressDeleteSuccess: '住所を削除しました。',
	addressEdit: '住所を編集',
	addressFlags: '国旗',
	addressInvoice: '請求先住所',
	addressInvoiceDifferentAsShippingLabel: '請求先の情報は配送先住所と同じですか？',
	addressInvoiceSelectionTitle: '請求先住所を選択してください',
	addressInvoiceUsedFor: '請求書に使用',
	addressInvoiceUse: '請求書に使用する',
	addressLabel: '住所の名称（例：自宅）',
	addressLegalInformation: '法的情報',
	addressMy: '登録済みの住所',
	addressName: 'お届け先のお名前',
	addressNoItems: 'まだ住所が登録されていません。',
	addressPhone: '電話番号（配送時のご連絡用）',
	addressPostalCode: '郵便番号',
	addressRegion: '州 / 地域',
	addressShipping: '配送先住所',
	addressShippingSelectionTitle: '配送先住所を選択してください',
	addressStreet1: '住所',
	addressStreetNumberHint: '番地をお忘れなく。番地がないと配送業者が住所を特定できないことがあります。',
	addressPostalCodeInvalid: 'この郵便番号は選択した国と一致しません。',
	addressPhoneInvalid: 'この電話番号は正しくないようです。配送業者が連絡に使用します。',
	addressPhoneMobileHint: '携帯番号を推奨します。配送業者はSMSで不在通知を送ります。',
	addressIssueTitle: 'この住所は発送前に補完が必要です',
	addressIssueIncomplete: '必須項目が不足しています。',
	addressIssuePostalCode: '選択した国の郵便番号を確認してください。',
	addressIssuePhone: '連絡可能な電話番号が必要です。配送業者が電話または不在通知を送ります。',
	addressIssueRegion: '配送業者が求める州または県を選択してください。',
	addressIssueTaxId: 'この配送先では税関が納税者番号を求めます。',
	addressCustomsHint: '荷物の通関手続きに必要です。',
	addressTaxIdRfc: 'メキシコの納税者番号（RFC）',
	addressTaxIdCpf: 'ブラジルの納税者番号（CPF）',
	addressTaxIdRut: 'チリの納税者番号（RUT）',
	addressTaxIdPccc: '個人通関コード（PCCC）',
	addressTaxIdCuil: 'アルゼンチンの納税者番号（CUIL）',
	addressTaxIdNationalId: '国民ID番号',
	addressTaxIdNorwayNid: 'ノルウェー国民ID（11桁）',
	addressIssueComplete: 'この住所を補完する',
	addressStreet2: '建物名・部屋番号・暗証番号など',
	administrationTitle: '管理',
	affiliationComment: 'コメント',
	affiliationCommission: '報酬',
	affiliationCommissionMultiplePendingAlert: 'このリストは概算です：注文と報酬はまだ確定していません。',
	affiliationCommissionPendingAlert: 'この注文は承認待ちです',
	affiliationDeleteConfirmMessage: 'このアフィリエイトを削除してもよろしいですか？',
	affiliationInvoiceTotalTitle: '受け取り金額の合計（税込）',
	affiliationKey: 'アフィリエイトキー',
	affiliationLegalApplyVAT: '消費税を適用しますか？',
	affiliationLegalInformations: '法的情報（請求先、事業者登録番号など）',
	affiliationMy: 'マイアフィリエイト',
	affiliationOptionValidityDays: 'アフィリエイトリンクの有効期間（日数）',
	affiliationSince: '登録日',
	affiliationViewResultsMy: 'アフィリエイト収益を見る',
	affiliations: 'アフィリエイト',
	alertContactError: 'メッセージを送信できませんでした。もう一度お試しください。',
	alertContactSuccess: '承りました',
	alertConversationNoExists: 'この会話は存在しません。',
	alertFetchApiError: 'ただいまサーバーに接続できません。しばらくお待ちください。',
	alertFormRequiredFieldsError: '必須項目をすべて入力してください。',
	alertGenericError: 'エラーが発生しました。しばらくしてからもう一度お試しください。',
	alertInstitutionAlreadyExists: 'この団体はすでに登録されています。',
	alertJsonParseError: 'サーバーから不正な応答が返されました。',
	alertOrderValid: 'ご注文の準備を開始できます。',
	alertUnauthorized: 'セッションの有効期限が切れました。もう一度ログインしてください。',
	alertUserAlreadyExists: 'このメールアドレスはすでに登録されています。',
	alertUserRegisterSuccess: 'ようこそ！',
	app404ErrorText: 'お探しのページが見つかりませんでした。ホームまたはマイアカウントにお戻りください。',
	app404ErrorTitle: '道に迷ってしまいました...',
	appAccessButton: '{app}にアクセス',
	appAgreementAcceptButton: '利用規約を読む',
	appAgreementAcceptHelp: 'このリンクをクリックすると利用規約をご確認いただけます。',
	appAgreementAcceptClickHint: 'こちらをクリックして同意にチェックを入れてください',
	appAgreementAcceptLabel: '利用規約を読み、同意します',
	appApplication: 'アプリケーション',
	appBackHomeButton: 'ホームに戻る',
	appBackHomeTitle: '道に迷ってしまいました...',
	appBugErrorText: '問題が発生しました。申し訳ございません。下のリンクをクリックして、このページを再読み込みしてください。',
	appConditionsAcceptTitle: '利用規約',
	appConditionsCheckError: '利用規約を確認したことにチェックを入れてください。',
	appConditionsCheckLabel: '利用規約を読み、同意します',
	appConditionsCheckSuccess: '承りました',
	appConditionsUpdateDate: '{date}に更新',
	appConfig: '設定',
	appConfiguration: '設定',
	appCookieConsentPrivacyLink: 'プライバシーポリシーをご確認ください',
	appCookieConsentText: '当サイトの閲覧を続けることで、サービスの正常な提供および統計を目的としたCookieの使用に同意したものとみなされます。お客様の事前の同意なく個人情報が提供されることはありません。',
	appCreateIndexButton: 'データベースのインデックスを作成',
	appDataPrivacyCheckButton: 'データ保護方針をお読みください',
	appDatabase: 'データベース',
	appErrorAlertText: '予期しない問題が発生しました。ご安心ください。お問い合わせいただければ、できるだけ早く解決いたします。',
	appErrorAlertTitle: 'エラーが発生しました',
	appForceUpdateApp: 'アプリを強制更新',
	appForceUpdateAppWeb: 'Webアプリを強制更新',
	appHome: 'ホーム',
	appMaintenanceModeText: 'しばらくお待ちいただき、少し経ってから再度アクセスしてください。',
	appMaintenanceModeTitle: '現在メンテナンス中です',
	appProcessLaunch: '起動プロセス',
	appQuestionLink: 'ご質問はありますか？',
	appRewiewsHeaderText: 'フランスで 🇫🇷 愛情を込めて製作 ❤️ - 4.6 ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ Trustpilotレビュー500件以上',
	appShopOrderHistory: 'ご注文履歴',
	appStart: '本をつくる',
	appVersion: 'バージョン',
	appVersionCurrent: '現在のアプリバージョン：{version}',
	appWebsiteAboutUs: '私たちの物語',
	appWebsiteBlog: 'ブログ',
	appWebsiteBook: '本について',
	appWebsiteConversationAndroid: 'AndroidのSMSを印刷する',
	appWebsiteConversationInstagram: 'Instagramのメッセージを印刷する',
	appWebsiteConversationIos: 'iPhoneのiMessage・SMSを印刷する',
	appWebsiteConversationMessenger: 'Messengerのメッセージを印刷する',
	appWebsiteConversationWhatsapp: 'WhatsAppのメッセージを印刷する',
	appWebsiteConversations: 'メッセージアプリを選ぶ',
	appWebsiteFaq: 'よくあるご質問',
	appFooterQuestion: 'ご質問がありますか？',
	appFooterTerms: '利用規約',
	appWebsitePrices: '料金',
	appWelcomeTitle: '{name}へようこそ',
	autocompleteSearch: '入力して検索…',
	apply: '適用',
	back: '戻る',
	by: '作成者：',
	cancel: 'キャンセル',
	cartAddTo: 'カートに追加',
	cartAuthInfo: '続けるにはメールアドレスを入力してください。',
	cartContinuePurchase: '買い物を続ける',
	cartEmptyError: 'カートは空です。',
	cartItemsRemoveAll: 'すべて削除',
	cartMy: 'マイカート',
	cartMyEdit: 'カートを編集',
	cartNextStepButton: '次のステップへ',
	cartNoItems: 'カートに商品がありません。',
	cartNote: '備考',
	cartProgression: 'カートの進行状況',
	cartSalesConditionsAccept: 'ご注文を確定すると、当社の販売条件に同意したものとみなされます。',
	cartSee: 'カートを見る',
	cartShipping: '配送',
	cartShippingFeeError: 'この住所へはお届けできません。別の住所をご入力ください。',
	cartStepConfirmationTitle: '確認',
	cartStepInvoiceTitle: '請求情報',
	cartStepPaymentTitle: 'お支払い',
	cartStepPreviewTitle: 'カート',
	cartStepShippingTitle: '配送',
	cartTotalShipping: '配送料',
	cartTotalSubTotal: '小計',
	cartTotalTax: '消費税',
	cartTotalTotal: '合計',
	cartValidButton: 'ご注文を確定',
	checkoutEyebrow: 'ご注文内容',
	checkoutStepUpsellTitle: '1冊、それとも2冊？',
	checkoutStepUpsellTitleGroup: '1冊、2冊、それとももっと？',
	checkoutStepUpsellHint: 'ご自分用に、大切な方への贈り物に、あるいはその両方に。',
	checkoutStepUpsellHintGroup: 'みんなに1冊ずつ：2冊目から割引が適用されます。',
	checkoutStepShippingTitle: 'お届け先を教えてください',
	checkoutStepShippingHint: '心を込めて印刷し、世界中どこへでもお届けします。',
	checkoutStepInvoiceTitle: 'お客様の情報',
	checkoutStepInvoiceHint: '請求書の発行とご注文状況の確認に使用します。',
	checkoutStepPaymentTitle: '安全にお支払い',
	checkoutStepPaymentHint: 'クレジットカード、Apple Pay、Google Pay：暗号化されたお支払いです。',
	checkoutPdfReadyTitle: 'eBookの準備ができました',
	checkoutPdfReadyHint: '配送は不要です：ご注文を完了してください。',
	checkoutSummaryEyebrow: 'ご注文の概要',
	cartReassuranceSecure: '安全なお支払い',
	cartReassuranceReturn: '返金保証',
	cartReassuranceSupport: 'カスタマーサポート',
	checkoutPromoEyebrow: 'クーポン',
	checkoutGiftEyebrow: 'ギフトカード',
	checkoutGiftCodeLabel: 'ギフトコード',
	checkoutGiftCodePlaceholder: 'ギフトコードを入力してください',
	checkoutGiftCodeHint: 'ギフトカードをお持ちですか？こちらにコードを入力してください。',
	checkoutGiftToggle: 'ギフトカードをお持ちですか？',
	checkoutAddCopy: 'もう1冊追加',
	checkoutSecondCopyKicker: 'ご自分用に、贈り物に',
	checkoutSecondCopyKickerGroup: '一人一冊',
	checkoutSecondCopyTitle: '追加の1冊は半額',
	checkoutSecondCopyTitlePercent: '追加の1冊',
	checkoutSecondCopyFor: 'この1冊',
	checkoutSecondCopyForGroup: '2冊目',
	checkoutSecondCopyChip: '2冊目は半額',
	checkoutSecondCopyChipPercent: '2冊目は{percent}%オフ',
	checkoutSecondCopySet: '全{count}巻、まとめて',
	checkoutSecondCopyPerBook: '1冊あたり',
	checkoutSecondCopySetPrice: '{count}巻で{price}',
	checkoutExtraBooksChip: '追加の本は半額',
	checkoutExtraBooksChipPercent: '追加の本は−{percent}%',
	checkoutGroupQtyHint: '3冊目も、追加の1冊ずつ−{percent}%です。',
	productExtraCopyRate: '追加の本（1冊の価格に対する%）',
	productExtraCopyRateHelp: '2冊目以降の各本は、1冊の価格のこの割合です。空欄：50%。0：数量割引。',
	checkoutGroupPicksLabel: '冊数',
	checkoutGroupAddSecond: '2冊目',
	checkoutGroupAddThird: '3',
	checkoutGroupAddSecondAria: '2冊目を半額で追加',
	checkoutGroupAddThirdAria: '3冊にする',
	checkoutQtyGroupHint: '一人一冊。2冊目から割引になります。',
	checkoutQtyPdfSingle: 'eBook 1冊',
	checkoutQtyMoreAriaLabel: 'その他の数量',
	checkoutQtyVolumeBreakdown: '{copies}部 × {volumes}巻 = 合計{total}冊',
	checkoutOfferBookCount: '{count}冊',
	checkoutUpsellTwoHint: '贈り物にも最適です：2冊目を追加すると、割引が自動的に適用されます。',
	checkoutEmptyTitle: '進行中のご注文はありません',
	checkoutEmptyHint: '本の画面に戻って、仕様をお選びください。',
	checkoutEmptyCta: '会話一覧を見る',
	checkoutBookAsideEyebrow: 'ご注文の本',
	checkoutBookAsideEyebrowPlural: 'ご注文の本',
	checkoutBookAsideVolume: '巻',
	checkoutBookAsideVolumes: '巻',
	checkoutBookAsideShelfLabel: 'ご注文の{count}巻',
	checkoutBookAsideEbook: 'eBook',
	checkoutBookAsidePaper: '紙の本',
	checkToggler: 'すべて選択／解除',
	choose: '選択',
	close: '閉じる',
	code: 'コード',
	cmsDeleteConfirmTitle: 'コンテンツを削除',
	cmsDeleteConfirmMessage: 'このコンテンツを削除してもよろしいですか？',
	cms: 'CMS',
	cmsAdminListHint: 'ページ、パネル、翻訳を編集します。国旗アイコンは言語ごとの翻訳ステータスを示します。',
	cmsPageAdd: 'ページを追加',
	cmsContentDuplicateSuccess: 'CMSコンテンツを複製しました！',
	companyShippingEdit: '配送方法を編集',
	conditions: '規約',
	configMissingKeyAlert: '設定キーのプロパティがありません！',
	configAdminHint: 'アプリケーションの設定、アフィリエイト、バックグラウンド処理、設定キーの生データ。',
	configuration: '設定',
	confirm: '確認',
	confirmMessage: 'この操作を実行してもよろしいですか？',
	confirmTitle: 'よろしいですか？',
	contactButton: 'お問い合わせ',
	contactMessage: 'メッセージ',
	contactPageButton: '送信',
	contactPageText1: 'お困りですか？ご不明な点がありますか？お気軽にご相談ください！',
	contactPageTitle: 'お問い合わせ',
	contactSend: '送信',
	continue: '続ける',
	console: 'コンソール',
	country: '国',
	conversationActionContinue: '続ける',
	conversationActionRestart: 'やり直す',
	conversationAddTitle: '会話を追加',
	conversationAdminDeleteConfirmTitle: '会話を削除',
	conversationAdminDeleteConfirmMessage: 'この会話とすべてのメディアが完全に削除されます。この操作は取り消せません。',
	conversationAdminListHint: 'すべてのお客様の会話を閲覧・検索・管理できます。ステータスタブで各ステップに絞り込めます。',
	conversationArchiveError: 'アーカイブファイルを読み取れませんでした。お手数ですが、お問い合わせいただけますと幸いです。',
	conversationBookOrderTypeBook: '本 + eBook（無料）',
	conversationBookOrderTypePdf: 'eBookのみ',
	conversationBookPreview: 'プレビュー',
	conversationBookPreviewSelected: '第{number}巻のプレビュー',
	conversationBookSelector: '編集する本を選択してください',
	conversationBookTypeLabelBook: '紙の本 + eBook',
	conversationBookTypeLabelPdf: 'eBookのみ',
	conversationBooks: '本',
	conversationCollectorArchiveSelectButton: 'アーカイブをアップロード',
	conversationCollectorInitWaiting: 'データを準備しています。しばらくお待ちください',
	conversationCollectorUseArchive: 'データのバックアップ（アーカイブ）をアップロード',
	conversationCoverBookEdit: '表紙をカスタマイズ',
	conversationCoverBookReset: 'この本の表紙をリセット',
	conversationCoverApplyToAllBooks: 'この表紙をすべての巻に適用',
	conversationCoverAutoAppliedToAllBooks: '表紙を他の巻にも適用しました。',
	conversationCoverApplyToAllBooksTitle: 'この表紙をすべての巻に適用してもよろしいですか？',
	conversationCoverApplyToAllBooksMessage: '他のすべての巻に適用する要素を選択してください。',
	conversationCoverApplyOptionColor: '色',
	conversationCoverApplyOptionPhoto: '写真',
	conversationCoverApplyOptionTitle: 'タイトル',
	conversationCoverApplyOptionSubtitle: 'サブタイトル',
	conversationCoverBookSwitchAlertMessage: 'この本の表紙情報のみが保存されます。',
	conversationCoverBookSwitchAlertTitle: 'この本の表紙を保存しますか？',
	conversationCoverColorEditTitle: '表紙の選択',
	conversationCoverLuxEyebrow: '表紙',
	conversationCoverLuxHint: 'デザインと色を選んでから、表紙を整えてください。',
	conversationCoverResumeLuxEyebrow: 'まえがき',
	conversationCoverResumeLuxHint: '任意：この文章は表紙の裏に印刷されます。',
	conversationCoverBookNumber: '第{number}巻',
	conversationCreationDate: '作成日',
	conversationCustomImportUpload: '生成したファイルをインポート',
	conversationCoverFooterPrefaceGuide: 'まえがきを省略する場合はプレビューに戻ってください。書く場合はそのまま進みます（任意、表紙の裏に印刷されます）。',
	conversationCoverFooterNextPreface: 'まえがき（任意）',
	conversationCoverFooterSkipPreface: 'まえがきを省略 · プレビューに戻る',
	conversationCoverFooterBackToCover: '表紙に戻る',
	conversationCoverFooterFinishPreview: '完了 · プレビューに戻る',
	conversationCoverFooterGoPreview: 'プレビューに戻る',
	conversationCoverEditionTypeTitle: '本の仕様',
	conversationCoverEditionTypeBookHelp: '全巻セットでは、各巻の表紙を1冊ずつカスタマイズできます。',
	conversationCoverColorSelectorHelp: '表紙の色を選んでください',
	conversationCoverStyleSelectorHelp: 'カバーのデザインを選んでください',
	conversationCoverStylePhoto: 'ポラロイド',
	conversationCoverStyleIncipit: '最初のメッセージ',
	conversationCoverPickMessageTitle: 'メッセージを選ぶ',
	conversationCoverEditQuote: '文を直す',
	conversationCoverPickMessageHint: '選んだ一文が、表紙に大きく載ります。',
	conversationCoverPickMessageSearch: 'メッセージを探す',
	conversationCoverPickMessageEmpty: '該当するメッセージがありません。',
	conversationCoverAddQuote: '一文を加える',
	conversationCoverHourLabel: '時刻',
	conversationCoverDateLabel: '日付',
	conversationCoverGroupNameLabel: 'グループ名',
	conversationCoverSpanLabel: '最初と最後のメッセージの日付',
	conversationCoverApplyOptionStyle: 'デザイン',
	conversationCoverApplyOptionQuote: '一文',
	conversationCoverDragNDropFiles: 'ここに画像をドラッグ＆ドロップしてください',
	conversationCoverTapToSelectPhoto: 'タップして写真を選択',
	conversationCoverOpenFinder: '画像を選択してください',
	conversationCoverPhotoSelectorTitle: '写真を選んでください',
	conversationCoverPhotoEditHint: 'クリックして写真を変更',
	conversationCoverPhotoChoose: 'クリックして写真を選ぶ',
	conversationPreviewSwipeHint: 'スワイプしてページをめくってください',
	conversationPreviewOpenBookHint: '表紙をスワイプして本を開いてください',
	conversationPreviewDiscoverBook: '本の中を見る',
	conversationPreviewVolumesLabel: 'コレクション：全{count}冊',
	conversationPreviewVolumesHint: '表紙をタップするとその巻を開けます。',
	conversationCoverResumeEditTitle: 'まえがきを書く（任意）',
	conversationCoverResumeError: 'まえがきが長すぎて1ページに収まりません。文章を短くするか、改行を減らしてください。',
	conversationCoverResumeNearLimit: '1ページの上限に近づいています（{lines}/{max}行）。',
	conversationCoverResumeHelp: 'このまえがきは表紙の裏に印刷されます。',
	conversationCoverResumePlaceholder: 'まえがきを書いてください',
	conversationCoverResumeReset: 'この本のまえがきをリセット',
	conversationCoverTitleError: 'タイトルが長すぎます（最大{max}文字）',
	conversationCoverTitleHelp: 'クリックして本のタイトルを編集',
	conversationCoverTitlePlaceholder: 'タイトルを入力してください...',
	conversationCoverDefaultTitleTwoNames: '{name1}と{name2}',
	conversationCoverDefaultTitleGroup: '私たちのグループ',
	conversationCoverDefaultTitleSingle: '私のメッセージ',
	conversationCoverWaitingForCustomization: '表紙は次のステップでカスタマイズできます...',
	conversationCreateInfoText: 'こちらのアイコンをクリックして、新しい本を作成しましょう',
	conversationCreateMyBookTitle: '自分の本を作る',
	conversationCreateTitle: '本を作成',
	conversationDateCreation: '作成日',
	conversationDateDownloadedInfo: '本は{downloaded}にダウンロードされました',
	conversationDateEnd: '会話の終わり',
	conversationDateEndInfo: '本は{end}で終わります',
	conversationDateEndLabel: '終了日を選択',
	conversationDateEndMessageSelection: 'ここで本を終える',
	conversationDateGeneratedInfo: '本は{generated}に生成されました',
	conversationDateRange: '{start}から{end}まで',
	conversationDeleteConfirmation: '会話を削除しました！',
	conversationDateSelectionAlert: '転送中に会話のデータが破損したようです。ページを開いたまま、安定したインターネット接続でもう一度お試しください。',
	conversationDateSimulatedInfo: '本は{simulated}に閲覧されました',
	conversationDateStart: '会話の始まり',
	conversationDateStartInfo: '本は{start}から始まります',
	conversationDateStartLabel: '開始日を選択',
	conversationDateStartMessageSelection: 'ここから本を始める',
	conversationDatesLuxEyebrow: '物語',
	conversationDatesLuxHint: '本の開始日と終了日を選んでください。メッセージをクリックすると選択範囲を細かく調整できます。',
	conversationDatesLuxNextEnd: '終了日',
	conversationDatesLuxBackStart: '開始日',
	conversationDatesLuxSavePreview: '保存 · プレビューに戻る',
	conversationDatesPresetsLabel: '期間のクイック選択',
	conversationDatesPreset_all: '会話全体',
	conversationDatesPreset_year: '過去1年',
	conversationDatesPreset_sixMonths: '過去6か月',
	conversationDatesSelectionCount: '{count, number}件の{count, plural, one {メッセージ} other {メッセージ}}',
	conversationDatesSelectionPeriod: '{start}から{end}まで',
	conversationDatesStoryDuration: 'この選択範囲は{duration}にわたります',
	conversationDatesStartCaption: 'いちばん最初のメッセージ',
	conversationDatesEndCaption: 'いちばん最後のメッセージ',
	conversationDatesBookMessages: '選択範囲にメッセージ{messages, number}件、写真{photos, number}件、メディア{medias, number}件',
	conversationDateSelectionEmpty: 'この期間にはメッセージがありません。選択範囲を広げてください。',
	conversationDatesEditTitle: '日付の選択',
	conversationDemoAlert: '本の最初の数ページをご覧いただけます。<br></br>ご注文後、印刷前に確認できる完全版をお送りします。',
	conversationDemoEndAlert: '残りのメッセージは、ご購入の確定後にご覧いただけます。',
	conversationPreviewEndTitle: '続きが待っています',
	conversationPreviewEndBody: '残りのメッセージはご注文後にご覧いただけます。印刷前に、本の完全版をお届けします。',
	conversationPreviewEndCta: '今すぐご注文',
	conversationPreviewEndBodyPaused: '変更内容を確定してください。デジタル版をすぐメールでお送りしますので、内容をご確認ください。',
	conversationPreviewEndCtaPaused: '変更を確定',
	conversationPreviewPrefaceOptionalBadge: '任意',
	conversationPreviewPrefaceEmptyTitle: 'まえがきを添えませんか？',
	conversationPreviewPrefaceEmptyText: '本の冒頭に添える短い文章です：ご記入は任意です。',
	conversationPreviewPrefaceEmptyButton: 'まえがきを追加',
	conversationPreviewPrefaceEditButton: 'まえがきを編集',
	conversationPreviewCoverEditButton: '表紙を編集',
	conversationPreviewCoverOpenLabel: '本を開く',
	conversationDisclaimerSubtitle: '形式を選んで、カスタマイズ画面へお進みください。',
	conversationDisclaimerTitle: '{count} {count, plural,\n		=0 {メッセージ}\n		=1 {メッセージ}\n		other {メッセージ}\n	}：読む価値のある物語',
	conversationDisclaimerSavings: '{value}お得です',
	conversationDisclaimerEBookIncluded: 'eBook版付き',
	conversationDisclaimerGenerating: '本を作成しています...',
	conversationDisclaimerPlanSingleTitle: '第1巻',
	conversationDisclaimerPlanSingleDescription: 'エッセンシャル',
	conversationDisclaimerPlanSingleButtonText: '自分の本を作る',
	conversationDisclaimerPlanSingleFeaturePages: 'お好きな本1冊（400ページ）をお届け',
	conversationDisclaimerPlanSingleFeatureQuality: '',
	conversationDisclaimerPlanSingleFeatureEvolutive: '拡張可能：続きは後から追加できます',
	conversationDisclaimerPlanSingleFeaturePremiumPaper: 'プレミアム用紙',
	conversationDisclaimerPlanSingleFeaturePremiumPrint: 'プレミアム用紙への印刷',
	conversationDisclaimerPlanSingleFeaturePdfIncluded: 'PDF版付き（{price}相当）',
	conversationDisclaimerPlanSingleFeatureWorkshop: '完全カスタマイズが無料',
	conversationDisclaimerPlanSingleFeatureMedia: '写真・動画・音声を収録',
	conversationDisclaimerPlanCollectionTitle: 'コンプリートコレクション',
	conversationDisclaimerPlanCollectionDescription: '全巻セット',
	conversationDisclaimerPlanCollectionButtonText: '私たちの物語をすべて残す',
	conversationDisclaimerPlanCollectionBadge: 'セット割 -{percentage}%',
	conversationDisclaimerPlanCollectionFeatureBox: '{count}冊の本を印刷してお届け',
	conversationDisclaimerPlanCollectionFeatureDiscount: 'コレクション価格 -{percentage}%（-{amount}の割引を適用）',
	conversationDisclaimerPlanCollectionFeatureDigital: '電子版が無料',
	conversationDisclaimerPlanCollectionFeatureWorkshop: '完全カスタマイズが無料',
	conversationDisclaimerPlanCollectionFeatureMedia: '写真・動画・音声を収録',
	conversationDisclaimerPlanEbookTitle: '電子書籍版',
	conversationDisclaimerPlanEbookDescription: 'デジタル',
	conversationDisclaimerPlanEbookButtonText: 'PDFで保存',
	conversationDisclaimerPlanEbookFeaturePdf: '高画質PDFをすぐにお届け',
	conversationDisclaimerPlanEbookFeatureShare: 'かんたんに共有',
	conversationDisclaimerPlanEbookFeatureMessages: '{count}件のメッセージをすべて収録',
	conversationDisclaimerPlanEbookFeatureMedia: '写真・動画・音声を収録',
	conversationDisclaimerReassuranceGuaranteeTitle: '満足保証・返金対応',
	conversationDisclaimerReassuranceGuaranteeDescription: '最終確認までは、ご依頼いただければ返金いたします。',
	conversationDisclaimerReassuranceCustomTitle: '自由にカスタマイズ',
	conversationDisclaimerReassuranceCustomDescription: 'お支払い後も表紙やメッセージを編集できます',
	conversationDisclaimerReassuranceSecureTitle: '100%安全なお支払い',
	conversationDisclaimerReassuranceSecureDescription: 'クレジットカード、Apple Pay、Google Pay、Link',
	conversationDisclaimerReassuranceDeliveryTitle: 'スピード配送',
	conversationDisclaimerReassuranceDeliveryDescription: '5営業日以内にお届け',
	conversationDisclaimerReviewSuffix: '{count}冊以上の印刷実績にもとづく評価',
	conversationDowloadUnableAlert: '会話の本はダウンロードできなくなりました。解決方法をご案内しますので、お問い合わせください。',
	conversationDownloadBackPreview: '本のプレビューに戻る',
	conversationDownloadDeadlineInfo: '{date}までファイルをダウンロードできます',
	conversationDownloadEyebrow: '本が完成しました',
	conversationDownloadHint: 'PDFをダウンロードして、会話のデジタル版を保存しておきましょう。',
	conversationDownloadLoading: 'ファイルを準備しています…',
	conversationDownloadLink: '{index}冊目の本をダウンロード',
	conversationDownloadFileCoverLink: '表紙「{name}」をダウンロード',
	conversationDownloadFileSourceLink: '元ファイル「{name}」をダウンロード',
	conversationDownloadPdfButton: '電子書籍をダウンロード',
	conversationDownloadPdfWaitingMessage: 'もう一度ダウンロードするには、5分お待ちください。',
	conversationEditStart: '本を編集',
	conversationEditSuccess: '会話を編集しました！',
	conversationFlags: 'フラグ',
	conversationImages: '画像',
	conversationMedias: 'メディア',
	'conversationFormatLabelA4-1': '思い出のクロニクル',
	'conversationFormatLabelA4-2': '（A4アルバム）',
	'conversationFormatLabelA5-1': '小さな宝物',
	'conversationFormatLabelA5-2': '（A5ノート）',
	conversationGeneratedSuccess: 'おめでとうございます！ <br></br> 会話の本が完成しました！',
	conversationGenerationAlert: '本を制作しています…',
	conversationGenerationAlert2: '少しだけお待ちください。すぐに完成します。',
	conversationGenerationFailed: '本の制作が途中で止まりました。',
	conversationGenerationFailedHint: 'メッセージは保存されています。もう一度お試しください。それでも続く場合はお問い合わせください。一緒に確認いたします。',
	conversationGenerationRetry: 'もう一度試す',
	conversationHelpBooksText: '本を切り替えて、それぞれの情報を編集できます',
	conversationHelpBooksTitle: '本の選択',
	conversationHelpCoverColorText: '円をクリックすると、表紙の背景色を変更できます。',
	conversationHelpCoverColorTitle: '表紙の色',
	conversationHelpCoverImageText: 'このスペースに画像ファイルをドラッグ＆ドロップすると、表紙に追加できます。',
	conversationHelpCoverImageTitle: '表紙の画像',
	conversationHelpCoverTitleText: 'タイトルをクリックすると編集できます。編集できる行は2行あります：タイトルとサブタイトル',
	conversationHelpCoverTitleTitle: '表紙のタイトル',
	conversationHelpDatePreviewText: '本の開始日を選択してください。',
	conversationHelpDatePreviewTitle: '日付',
	conversationHelpDateSelectorText: '日付を変更すると、最初と最後のメッセージがここに表示されます！',
	conversationHelpDateSelectorTitle: 'メッセージのプレビュー',
	conversationHelpParticipantColorText: '参加者ごとに吹き出しの色を変更できます',
	conversationHelpParticipantColorTitle: '参加者の色',
	conversationHelpParticipantNameText: '参加者の名前は自由に変更できます！',
	conversationHelpParticipantNameTitle: '参加者の名前',
	conversationHelpParticipantPositionText: '参加者の吹き出しを左右どちらに表示するか選べます',
	conversationHelpParticipantPositionTitle: '参加者の位置',
	conversationHelpMessagesToolsTitle: 'ツール',
	conversationHelpMessagesToolsText: 'タイルをタップして、検索、メディアや日付での絞り込み、メッセージの非表示ができます。',
	conversationHelpMessagesSearchTitle: '検索',
	conversationHelpMessagesSearchText: '単語や名前を入力すると、メッセージをすばやく見つけられます。',
	conversationHelpMessagesMediasTitle: 'メディア',
	conversationHelpMessagesMediasText: '写真・動画・音声・リンクを含むメッセージだけに絞り込めます。',
	conversationHelpMessagesDatesTitle: '日付',
	conversationHelpMessagesDatesText: '2つの日付の間のメッセージだけを残して、会話の一部に集中できます。',
	conversationHelpMessagesHidePeriodTitle: '期間を非表示',
	conversationHelpMessagesHidePeriodText: '2つの日付を選ぶと、その期間のメッセージをまとめて非表示（または再表示）できます。',
	conversationHelpMessagesHiddenTitle: '表示',
	conversationHelpMessagesHiddenText: 'すべてのメッセージ、表示中のみ、非表示のみを切り替えられます。',
	conversationHelpMessagesListTitle: 'メッセージを編集',
	conversationHelpMessagesListText: '各吹き出しで、選択・非表示・本文編集・新規挿入ができます。',
	conversationHelpMessagesFooterTitle: 'プレビューに戻る',
	conversationHelpMessagesFooterText: '完了したらプレビューに戻り、更新された本を確認しましょう。',
	conversationHelpPreviewBookCoverText: '世界にひとつだけの表紙に。クリックしてカスタマイズできます。',
	conversationHelpPreviewBookCoverTitle: '表紙',
	conversationHelpPreviewBookPreviewText: 'クリックすると、この本をひと足先にご覧いただけます。',
	conversationHelpPreviewBookPreviewTitle: '本のプレビュー',
	conversationHelpPreviewBookSelectorText: 'ご注文に含めたい巻を選択してください。',
	conversationHelpPreviewBookSelectorTitle: '本',
	conversationHelpPreviewBookSplitText: 'このオプションを有効にすると、それぞれの本のページ数が同じになります。',
	conversationHelpPreviewBookSplitTitle: 'ページ数を均等にする',
	conversationHelpPreviewCopyText: '複数冊のご注文もできます：自分用にも、プレゼント用にも。2冊目から割引になります。',
	conversationHelpPreviewCopyTitle: 'プレゼント用にもう1冊',
	conversationHelpPreviewFormatText: '紙の本か電子書籍か：お好みの形を選んでください。',
	conversationHelpPreviewFormatTitle: '形式',
	conversationHelpPreviewRenderText: 'こちらが本です。表紙はそのまま編集できます。そのあとページをめくってご確認ください。',
	conversationHelpPreviewRenderTitle: '本',
	conversationHelpPreviewMessagesText: 'このカードをタップして、メッセージの内容を編集できます。',
	conversationHelpPreviewMessagesTitle: 'メッセージ',
	conversationHelpPreviewDatesText: 'このカードをタップして、本の開始日と終了日を選べます。',
	conversationHelpPreviewDatesTitle: '日付',
	conversationHelpPreviewParticipantsText: 'このカードをタップして、参加者の名前や見た目を変更できます。',
	conversationHelpPreviewParticipantsTitle: '参加者',
	conversationHelpPreviewCoverTitleText: 'タイトルまたはサブタイトルをクリックして編集できます。',
	conversationHelpPreviewCoverTitleTitle: 'タイトルとサブタイトル',
	conversationHelpPreviewVolumesTitle: '複数の巻',
	conversationHelpPreviewVolumesText: '会話は複数の本に分かれています。番号をタップして巻を切り替え、各表紙をカスタマイズできます。',
	conversationHelpPreviewCoverImageText: '写真エリアをタップして表紙画像を追加・変更できます。',
	conversationHelpPreviewCoverImageTitle: '写真',
	conversationHelpPreviewCoverColorText: 'スウォッチをタップして表紙の背景色を変更できます。',
	conversationHelpPreviewCoverColorTitle: '色',
	conversationHelpPreviewValidText: '準備ができたら確認して進みましょう。電子書籍はメールで、本はご自宅にお届けします。',
	conversationHelpPreviewValidTitle: 'さあ、はじめましょう！',
	conversationHighlightStartDateTitle: '最初のメッセージ',
	conversationHighlightStartDateDescription: 'この日に最初のメッセージが届きました。すべてはここから始まりました。',
	conversationHighlightDurationTitle: '続いてきた日数',
	conversationHighlightDurationDescription: '最初のメッセージから、一緒に重ねた日々です。',
	conversationHighlightMessagesCountTitle: 'メッセージ',
	conversationHighlightMessagesCountDescription: '{date}から交わしてきたメッセージです。',
	conversationHighlightImagesCountTitle: '写真',
	conversationHighlightImagesCountDescription: '私たちのやり取りに残した写真です。',
	conversationHighlightMediasCountTitle: '動画と音声',
	conversationHighlightMediasCountDescription: '声をもう一度聞いて、あの瞬間に戻るために。',
	conversationHighlightSpecialDayMessagesCountTitle: 'いちばん賑やかな日',
	conversationHighlightSpecialDayMessagesCountDescription: '一日でいちばん多かった、私たちの記録です。',
	conversationHighlightSpecialDayTitle: 'その日',
	conversationHighlightSpecialDayDescription: '私たちがいちばん多くメッセージを交わした日です。',
	conversationHighlightCharsCountReferenceDiffTitle: 'ロミオとジュリエット',
	conversationHighlightCharsCountReferenceDiffDescription: 'ロミオとジュリエットの全文、これだけの回数分です。',
	conversationHighlightCharsCountReferenceDiffRomeoJuliette: '{diff}倍',
	conversationHighlightTypingDurationTitle: '文字を打った時間',
	conversationHighlightTypingDurationDescription: '私たちがメッセージを書くのに重ねた時間です。',
	conversationHighlightUnitDays: '日',
	conversationHighlightUnitMessages: '件',
	conversationHighlightUnitHours: '時間',
	conversationHighlightUnitTimes: '倍',
	conversationHighlightBadge: 'いくつかの数字で',
	conversationHighlightStoryKicker: 'あなたの物語',
	conversationHighlightsMomentsCount: 'ダウンロードできる画像が{count}枚',
	conversationHighlightShareFormat: 'ストーリーサイズ',
	conversationHighlightsCardFooter: '本にする価値のある物語もあります',
	conversationHighlightShareButton: 'ダウンロード',
	conversationHighlightShareButtonAlt: '会話の統計を見る',
	conversationHighlightShareImageButton: '画像を送る',
	conversationHighlightSubtitle: '交わした言葉を、数字で。',
	conversationHighlightTitle1: 'やり取りを',
	conversationHighlightTitle2: 'いくつかの数字で',
	conversationHighlightOpenStoryButton: 'このストーリーを開く',
	conversationHighlightsAtGlanceEyebrow: 'ひと目でわかる',
	conversationHighlightsAtGlanceTitle: 'ふたりの物語の大きさ',
	conversationHighlightsNoAiNote: 'これらの統計は、AIを使わずに自動で算出されます。',
	conversationHighlightsKpiMessages: 'メッセージ',
	conversationHighlightsKpiWords: '書いた言葉',
	conversationHighlightsKpiActiveDays: 'やり取りした日数',
	conversationHighlightsKpiStreak: '連続した日数',
	conversationHighlightsRhythmEyebrow: 'ふたりのリズム',
	conversationHighlightsRhythmTitle: 'メッセージが交わされるとき',
	conversationHighlightsTopHour: 'よく話す時間',
	conversationHighlightsTopWeekday: 'よく話す曜日',
	conversationHighlightsNightMessages: '夜のメッセージ',
	conversationHighlightsChartMonths: '最初から最後のメッセージまで、月ごと',
	conversationHighlightsChartYears: '最初から最後のメッセージまで、年ごと',
	conversationHighlightsLessThanOneMinute: '1分未満',
	conversationHighlightsSpanLessThanMonth: '1か月未満',
	conversationHighlightsSpanYears: '{count}年',
	conversationHighlightsSpanMonths: '{count}か月',
	conversationHighlightsSpanYearsMonths: '{years}年{months}か月',
	conversationHighlightsSpanLabel: '最初のメッセージから最後まで',
	conversationHighlightsBusiestDayLabel: 'いちばん盛り上がった日',
	conversationHighlightsPhotosLabel: '写真',
	conversationHighlightsMediasLabel: '動画とボイスメッセージ',
	conversationHighlightsBookPagesLabel: '本にすると',
	conversationHighlightsBookPagesPrefix: '約',
	conversationHighlightsBookPagesUnit: 'ページ',
	conversationHighlightsBookPagesNote: 'メッセージと写真からの推定です。',
	conversationHighlightsWritingHours: '書き合った時間は約{count}時間。',
	conversationHighlightsRomeo: 'ロミオとジュリエット約{count}作分。',
	conversationHighlightsDayClockPeak: '{start}時から{end}時がいちばん多い',
	conversationHighlightsLessThanOnePercent: '1%未満',
	conversationHighlightsWritesLonger: '{name}さんのメッセージがいちばん長いです。',
	conversationHighlightsStartsMore: '{name}さんが会話を始めることが多いです。',
	conversationHighlightsWordsPerMessage: '1通あたり{count}語',
	conversationHighlightsStartsShare: '開始の{percent}%',
	conversationHighlightsMedianReply: '返信時間の中央値',
	conversationHighlightsBalanceEyebrow: 'ふたりのバランス',
	conversationHighlightsBalanceTitle: 'それぞれの寄り添い方',
	conversationHighlightsWordsShort: '語',
	conversationHighlightsStartsShort: '会話のきっかけ',
	conversationHighlightsBalanceNote: '割合が表すのはふたりのリズムであり、その人の大切さではありません。',
	conversationHighlightsRecordsEyebrow: 'ふたりの記録',
	conversationHighlightsRecordsTitle: '印象に残る瞬間',
	conversationHighlightsLongestSession: 'いちばん長い会話',
	conversationHighlightsIntenseQuarter: '最も盛り上がった15分間',
	conversationHighlightsQuestions: 'やさしいメッセージ',
	conversationHighlightsSignsOfInterest: 'ハート、キス、「好き」',
	conversationHighlightsLaughs: '笑いのあるメッセージ',
	conversationHighlightsSharedSmiles: '分かち合った笑顔',
	conversationHighlightsFavoriteEmojis: 'お気に入りの絵文字',
	conversationHighlightsStoriesEyebrow: '残しておきたいもの',
	conversationHighlightsStoriesTitle: '思い出のカード',
	conversationHighlightsStoriesText: 'カードを開いて、ストーリー形式でダウンロードできます。',
	conversationHighlightsDeepEyebrow: '数字のその先へ',
	conversationHighlightsDeepTitle: 'ふたりの物語を、もっと深く読み解いてみませんか？',
	conversationHighlightsDeepText: 'いつかさらに深く知りたいと思ったら、ぜひお聞かせください。今のところ、これ以上の分析は行いません。',
	conversationHighlightsDeepThanks: 'ありがとうございます。ご関心を受け付けました',
	conversationHighlightsDeepButton: 'はい、興味があります',
	conversationHighlightsDeepNotice: '準備ができ次第、お知らせします。',
	conversationHighlightsDeepNoticeClose: 'わかりました',
	conversationHighlightsPrintBook: '本を印刷したい',
	conversationHighlightsPrintNow: '今すぐ印刷する',
	conversationHighlightsLoading: '数字をまとめています。',
	conversationHighlightsEmpty: '数字を取り出すには、もう少しやり取りが必要です。',
	conversationImagesCount: '{count}{count, plural,\n		=0 {枚の写真}\n		=1 {枚の写真}\n		other {枚の写真}\n  	}',
	conversationImportFileNotSupportedError: 'このファイルはアーカイブとして正しくありません。有効なアーカイブ（.zip）を選択してください。',
	conversationImportFileSummary: 'お名前は{name}で、このアーカイブには{count}件の会話があります。',
	conversationImportFileTooBigError: 'ファイルのサイズが大きすぎます（4GB以上）。解決方法をご案内しますので、お問い合わせください。',
	conversationImportProviderNext: '会話を転送',
	conversationImportTutorialGoNext: '続きを見る',
	conversationImportTutorialStep: 'ステップ{step}',
	conversationImportDetailToggle: 'スクリーンショット付きの詳しいガイドを見る',
	conversationImportDetailCardTitle: 'はじめてですか？',
	conversationImportDetailCardSubtitle: 'スクリーンショット付き、{count}ステップの図解ガイド',
	conversationImportDetailCardAction: 'ガイドを開く',
	conversationImportDetailTitle: 'ステップごとの詳しいガイド',
	conversationImportDetailStepOf: 'ステップ{current}/{total}',
	conversationImportDetailPrev: '戻る',
	conversationImportDetailNext: '次へ',
	conversationImportDetailClose: '閉じる',
	conversationImportSelectionSummary: '選択した会話：{name}（{count}{count, plural,\n			=0 {件のメッセージ}\n			=1 {件のメッセージ}\n			other {件のメッセージ}\n		}を含みます）',
	conversationImportSelectionSummary2: '選択した会話：{name}',
	conversationImportSelectionText: 'お友だちの名前を入力...',
	conversationImportSelectionTitle: '会話を選択してください',
	conversationImportStepCreation: '本の作成',
	conversationImportStepExtraction: 'ファイルの解析',
	conversationImportStepFinal: '最後の仕上げ',
	conversationImportStepImages: '写真のアップロード',
	conversationImportStepMedias: '動画と音声のアップロード',
	conversationImportStepMessages: 'メッセージの保存',
	conversationImportTransferStatMessages: 'メッセージ',
	conversationImportTransferStatPhotos: '写真',
	conversationImportTransferStatMedias: '動画と音声',
	conversationImportTransferEyebrow: 'あと少しです',
	conversationImportTransferTitle: '本を準備しています',
	conversationImportTransferSubtitle: '少しだけお待ちください。物語が形になっていきます。',
	conversationImportTransferStay: '転送が完了するまで、このページを開いたままにしてください。',
	conversationImportResumeTitle: '前回の転送が中断されました。',
	conversationImportResumeTextFile: '同じファイル（{name}）をもう一度選択すると、中断したところから再開できます。',
	conversationImportResumeText: '同じファイルをもう一度選択すると、中断したところから再開できます。',
	conversationImportResumeButton: '転送を再開',
	conversationImportResumeDiscard: 'やり直す',
	conversationImportDuplicateTitle: 'この会話はすでにアカウントに登録されています',
	conversationImportDuplicateEyebrow: '同じ内容の会話',
	conversationImportDuplicateLead: '同じ内容の会話が見つかりました。すでにある会話を開けば、重複した転送を避けられます。',
	conversationImportDuplicateQuestion: 'どうされますか？',
	conversationImportDuplicateUseExisting: '既存の会話を使う',
	conversationImportDuplicateImportAnyway: 'もう一度インポート',
	conversationImportSuccess: 'おめでとうございます！ <br></br>会話をインポートしました！',
	conversationImportValidationWaiting: '確認中...',
	conversationMediaAudioOpusWarning: 'このファイルを再生できない場合は、対応している別のブラウザ（Google Chromeなど）をお使いください。',
	conversationMediasCount: '{count}{count, plural,\n		=0 {件のメディア}\n		=1 {件のメディア}\n		other {件のメディア}\n	}',
	conversationMerge: '会話を統合',
	conversationMergeSelect: 'この会話を選択',
	conversationMergeUnselect: 'この会話の選択を解除',
	conversationMergeInfo: '統合する会話を選択し、リストの下にあるボタンをクリックしてください：',
	conversationMergeRequestSuccess: '会話はまもなく統合されます。統合が完了しましたらメールでお知らせします。',
	conversationMergeHintEyebrow: 'ご参考',
	conversationMergeHintTitle: '1つの会話にまとめる',
	conversationMergeHintSingle: '複数のチャットスレッドがありますか？+ ボタンで各会話をインポートし、1つの会話に統合できます。',
	conversationMergeHintReady: '会話を時系列の1つの会話に統合できます。',
	conversationMessages: 'メッセージ',
	conversationMessagesCount: '{count}{count, plural,\n		=0 {件のメッセージ}\n		=1 {件のメッセージ}\n		other {件のメッセージ}\n	}',
	conversationMessagesCount2: '{count, plural,\n		=0 {件のメッセージ}\n		=1 {件のメッセージ}\n		other {件のメッセージ}\n	}',
	conversationMessagesImagesCount: '{count}{count, plural,\n		=0 {枚の画像}\n		=1 {枚の画像}\n		other {枚の画像}\n	}',
	conversationMessagesImagesCount2: '{count, plural,\n		=0 {枚の画像}\n		=1 {枚の画像}\n		other {枚の画像}\n	}',
	conversationMessagesLoadingAlert: 'メッセージを取得しています...',
	conversationMessagesMediasCount: '{count}{count, plural,\n		=0 {件のメディア}\n		=1 {件のメディア}\n		other {件のメディア}\n	}',
	conversationMessagesMediasCount2: '{count, plural,\n		=0 {件のメディア}\n		=1 {件のメディア}\n		other {件のメディア}\n	}',
	conversationNoData: 'まだ会話が作成されていません！',
	conversationOptionWithImagesHelp1: '現在の設定では、本に画像や写真が含まれます',
	conversationOptionWithImagesHelp2: '現在の設定では、本に画像や写真は含まれません',
	conversationOptionWithImagesHelp3: '写真の枚数によっては、会話の転送に時間がかかることがあります。読み込み中はこのページを開いたままにしてください。最大で10分ほどかかる場合があります。それでもうまくいかない場合は、www.fromsmash.com からアーカイブを hello@monlivresms.com 宛にお送りください。その際、相手の方またはグループの名前もあわせてお知らせいただければ、解決方法をご案内します。',
	conversationOptionWithImagesLabel: '会話の画像を含めますか？',
	conversationOptionWithMediaHelp: '本に印刷されるQRコードから、動画・音声・GIFをもう一度お楽しみいただけます。データの保存は10年間無料です。',
	conversationOptionWithMediasLabel: '会話の動画・音声・GIFを含めますか？',
	conversationOrder: 'ご注文',
	conversationOrderButton: '今すぐご注文',
	conversationOrderButtonWithPrice: '注文する · {price}',
	conversationOrderButtonWithPriceVolumes: '{count}冊を注文する · {price}',
	conversationOrderDiscountLabel: '{threshold}冊以上のご注文で、この会話が-{discount}%割引',
	conversationOrderQuantity: '冊数',
	conversationOrderSummaryBook: '{bookCount}{bookCount, plural,\n			=1 {冊の本}\n			other {冊の本}\n		} · {bookTotal} {discount, plural,\n			=0 {}\n			other {：{discount}%割引込み}\n		}',
	conversationOrderSummary2: 'ご注文には{bookCount}{bookCount, plural,\n				=0 {冊の本}\n				=1 {冊の本}\n				other {冊の本}\n			}と{pdfCount}{pdfCount, plural,\n				=0 {冊の電子書籍}\n				=1 {冊の電子書籍}\n				other {冊の電子書籍}\n			}{freeCount, plural,\n				=0 {}\n				=1 {、さらに無料の電子書籍1冊}\n				other {、さらに無料の電子書籍{freeCount}冊}\n			}が含まれます（{pdfTotal}）',
	conversationOrderSummaryBestof: 'Best Of の本 1冊 · {bestofTotal}',
	conversationOrderSummaryPdf: '完全版の電子書籍1冊 · {pdfTotal}',
	conversationParticipantColorHelp: 'ここをクリックすると吹き出しの色を変更できます',
	conversationParticipantColorBlushClair: 'ライトブラッシュピンク',
	conversationParticipantColorCielClair: 'ライトスカイ',
	conversationParticipantColorLavandeClaire: 'ライトラベンダー',
	conversationParticipantColorPruneClaire: 'ライトプラム',
	conversationParticipantColorPecheClaire: 'ライトピーチ',
	conversationParticipantColorSaugeClair: 'ライトセージ',
	conversationParticipantColorMiel: 'ハニー',
	conversationParticipantColorPerle: 'パール',
	conversationParticipantNameHelp: 'ここをクリックすると参加者の名前を変更できます',
	conversationParticipantNameError: '名前が長すぎます（最大{max}文字）',
	conversationParticipantPositionHelp: 'クリックすると参加者の位置（右または左）を変更できます',
	conversationParticipantPositionLeft: '左',
	conversationParticipantPositionRight: '右',
	conversationParticipants: '参加者',
	conversationOrders: 'ご注文',
	conversationPrinterMode: '印刷モード',
	conversationParticipantsLuxEyebrow: '会話',
	conversationParticipantsLuxHint: '各参加者の名前、吹き出しの色、左右の位置を編集できます。',
	conversationParticipantsLuxSavePreview: '保存 · プレビューに戻る',
	conversationParticipantsLuxSaved: '保存しました',
	conversationParticipantsSameSideHint: '複数の参加者が同じ側に配置されています。左右の位置をご確認ください。',
	conversationParticipantsEditTitle: '参加者の編集',
	conversationPauseButton: 'ご注文を一時停止',
	conversationPauseConfirmText: '本の生成が一時停止されます。いつでも再開できます。',
	conversationPreviewBookNumber: '{index}{index, plural,\n			  =0 {}\n			  =1 {}\n			  =2 {}\n			  other {}\n		  }冊目の本',
	conversationPreviewBestofHelpButton: '選定の仕組みとは？',
	conversationPreviewBestofHelpText: '独自のアルゴリズムが会話のあらゆる瞬間を分析します：やり取りの密度、対話の質（お互いの会話か、一方的な発言か）、内容の豊かさ（写真、テキスト、絵文字）。最初と最後のメッセージは必ず残ります。本当に大切だった瞬間だけが本に収録されます。メッセージのプライバシーは守られます：アルゴリズムが内容を読み取ることはなく、やり取りの構造だけを分析します。',
	conversationPreviewBookSelection: '本の選択',
	conversationPreviewBooksSelectAllBooks: '紙の本をすべて選択',
	conversationPreviewBooksSelectAllEBooks: '電子書籍をすべて選択',
	conversationPreviewBooksUnselectAll: 'すべて選択解除',
	conversationPreviewBrowserWarning: 'お使いのブラウザでは表示が遅くなることがあります。快適にご利用いただくには Google Chrome をおすすめします。',
	conversationPreviewFormatSelection: '形式の選択',
	conversationPreviewPagesDivideEquallyLabel: 'ページ数を各本に均等に分けますか？',
	conversationPreviewPagesSetMaxBookPagesLabel: '1冊あたり{max}ページを目安にしますか？',
	conversationPreviewTitle: '物語を、一冊の本に。',
	conversationPreviewSubtitle: '表紙・名前・日付・メッセージを編集してから、仕様を選びましょう。',
	conversationPreviewHeroTitle: '言葉を、ずっと残る一冊に。',
	conversationPreviewBookCaption: 'ページをめくって、本をご覧ください。',
	conversationPreviewCustomizeEyebrow: '自分らしく',
	conversationPreviewEditionEyebrow: '仕様',
	conversationPreviewPricePerVolume: '{price}/巻',
	conversationPreviewCollectionPriceNote: '{count}巻 · {price}/巻',
	conversationPreviewCollectionUntilLabel: 'どの巻',
	conversationPreviewCollectionUntilAll: '最初の巻から最後の巻まで',
	conversationPreviewCollectionUntilOpen: '選ぶ',
	conversationPreviewCollectionUntilClose: '閉じる',
	conversationPreviewCollectionUntilPartial: '最初の{count}巻',
	conversationPreviewCollectionUntilSuffix: '最後の{count}巻',
	conversationPreviewCollectionUntilSingle: '{number}巻',
	conversationPreviewCollectionUntilWindow: '{from}巻から{to}巻まで',
	conversationPreviewCollectionUntilPeriod: '{start}から{end}まで',
	conversationPreviewCollectionUntilHint: '残りの巻は会話に残ります。次のご注文で作れます。',
	conversationPreviewCollectionUntilAriaStart: '印刷する最初の巻',
	conversationPreviewCollectionUntilAriaEnd: '印刷する最後の巻',
	conversationPreviewTypeBookTaglinePartial: '会話の最初の{count}巻です。',
	conversationPreviewTypeBookTaglineSuffix: '会話の最後の{count}巻です。',
	conversationPreviewTypeBookTaglineWindowSingle: '会話の{number}巻です。',
	conversationPreviewTypeBookTaglineWindow: '会話の{from}巻から{to}巻です。',
	conversationPreviewStickyCollectionVolumes: 'コレクション · {count}巻',
	conversationPreviewSocialProofCount: '{count}件以上のレビュー',
	conversationPreviewSocialProofAria: 'Trustpilot で5点満点中{rating}点、{count}件以上のレビューに基づく評価',
	conversationPreviewCustomizeTitle: '本をカスタマイズ',
	conversationPreviewCustomizeDone: 'カスタマイズを完了',
	conversationPreviewCustomizeClose: 'カスタマイズを閉じる',
	conversationPreviewEditionScrollLabel: '仕様のセクションへ移動',
	conversationPreviewEditionBelowHint: '仕様は下でお選びいただけます',
	conversationPreviewCustomizeHint: 'カードをタップすると編集できます。',
	conversationPreviewCardsHintTitle: '名前、期間、メッセージ',
	conversationPreviewCardsHintText: 'ここでは名前、期間、メッセージを変更できます。',
	conversationPreviewCustomizeTopics: '表紙 · 名前 · 日付 · メッセージ',
	conversationPreviewEditionTitle: '仕様を選ぶ',
	conversationPreviewEditionHint: '各オプションを比べて、お好みのものをお選びください。',
	conversationPreviewPausedEyebrow: 'ご注文は一時停止中',
	conversationPreviewPausedTitle: '変更の準備はできましたか？',
	conversationPreviewPausedHint: 'ご注文は一時停止中です。本を編集してから確定すると、製造を再開します。',
	conversationPreviewPausedScrollHint: '変更を確定',
	conversationPreviewMissingMediasBanner: '会話の一部のメディア（写真、ファイル）が見つからないか、取得できませんでした。確定する前にメッセージをご確認ください。',
	conversationPreviewMissingMediasCta: '不足メディアを補完',
	bookMissingPhotoLabel: '写真がありません',
	conversationMissingMediasBadge: '不足メディア',
	conversationMissingMediasCta: '不足メディアを補完',
	conversationResumeWithoutMediasButton: 'これらの写真なしで続ける',
	conversationResumeMissingMediasConfirmText: 'まだ不足している写真があります。本はそれらなしで印刷に進みます。可能ならメディアを補完してください。',
	orderMissingMediasAlert: 'この注文の会話に不足写真があります。製作再開のため補完してください。',
	missingMediasRecoveryAddPhoto: '写真を追加',
	missingMediasRecoveryArchiveCta: 'エクスポートファイルを置く',
	missingMediasRecoveryArchiveError: 'このファイルを読み取れませんでした。メッセンジャーのエクスポートか確認してください。',
	missingMediasRecoveryArchiveHelp: '{provider}のエクスポート（zip）を再度アップロードしてください。不足している写真だけが追加され、メッセージや編集内容はそのままです。',
	missingMediasRecoveryArchiveTitle: '新しいエクスポートで補完',
	missingMediasRecoveryArchiveWorking: 'ファイル内の不足写真を検索しています…',
	missingMediasRecoveryContact: 'お問い合わせ',
	missingMediasRecoveryEmpty: '現在、不足メディアは検出されていません。',
	missingMediasRecoveryError: 'エラーが発生しました。再試行するか、お問い合わせください。',
	missingMediasRecoveryFirstDate: '最初の不足メディア: {date}。',
	missingMediasRecoveryIgnore: '無視する',
	missingMediasRecoveryIntro: '本に写真が{count}件不足しています。エクスポートを再アップロードするか、下記で個別に対応できます。',
	missingMediasRecoveryListTitle: 'メディアを1件ずつ対応',
	missingMediasRecoveryNoMatch: '不足メディアに一致するファイルが見つかりませんでした。',
	missingMediasRecoveryRecommended: 'おすすめ',
	missingMediasRecoveryRescan: '再確認',
	missingMediasRecoveryResolved: '不足メディアの対応が完了しました。本の製作を再開します。',
	missingMediasRecoverySuccessEyebrow: '完了',
	missingMediasRecoverySuccessTitle: '写真の補完が完了しました',
	missingMediasRecoverySuccessText: '不足メディアの対応が完了しました。本の製作を再開します。',
	missingMediasRecoverySuccessCta: 'プレビューに戻る',
	conversationMissingMediasFixedSuccess: '不足メディアの補完が完了しました。本の製作を再開します。',
	conversationMissingMediasFixedHint: 'お客様側の作業は完了です。製作は自動で再開されます。',
	missingMediasRecoverySmsStepAndroid: 'Android: MonLivreSMSアプリを再度開き、会話を再送してください。',
	missingMediasRecoverySmsStepBackup: '暗号化なしの新しいローカルバックアップ（Mac/PC）を作成し、ソフトウェアを再実行してこの会話のメディアを再送してください。',
	missingMediasRecoverySmsStepIcloud: 'iPhone: メッセージで会話を開き、連絡先をタップして下にスクロールし、iCloud写真をダウンロードしてください。',
	missingMediasRecoverySmsTitle: 'SMS / iPhone転送',
	missingMediasRecoveryTitle: '不足メディア（{count}）',
	conversationPreviewEditionMetaLabel: '仕様の詳細',
	conversationPreviewBestofLearnMore: 'Best-Of の選定について知る',
	conversationPreviewBestofHint: 'こちらは Best Of のイメージプレビューです。ベストメッセージの選定はご注文後、PDFの生成時に行われます。',
	conversationPreviewBestofHintDismiss: '閉じる',
	conversationPreviewBestofHintLearnMore: '詳しく見る',
	conversationPreviewBestofPriceNote: '注文後にセレクト',
	conversationPreviewTypeBestofTaglineCompare: '軽めの選択肢：ベストなやりとりを1巻に。',
	conversationPreviewMetaEbook: '電子書籍が無料',
	conversationPreviewMetaVolume: '{count}巻',
	conversationPreviewMetaVolumes: '{count}巻',
	conversationPreviewMetaPages: '{pages}ページ',
	conversationPreviewMetaMessages: '{count}件のメッセージ',
	conversationPreviewMetaBestofPages: '約400ページ',
	conversationPreviewMetaBestofSelection: 'スマート選定',
	conversationPreviewMetaPdfInstant: 'すぐPDF',
	conversationPreviewMetaPdfCredit: '本へのクレジット',
	conversationPreviewPdfPriceNote: '本に進むと差し引き',
	conversationPreviewPdfLearnMore: '仕組みを見る',
	conversationPreviewPdfHelpText: '{ebookPrice}をお支払いいただくと、PDFをお届けします。あとで紙の本（{bookPrice}）をご注文の場合、この{ebookPrice}が差し引かれ、残りは{remainingPrice}です。クレジットはアカウントに残ります。',
	conversationPreviewReassurancePdfCredit: '本に進む場合、この{price}が差し引かれます',
	conversationPreviewStickyPdfCredit: '本に進む場合の{price}クレジット',
	conversationPreviewEbookCreditBanner: 'この会話には{amount}のクレジットがあります。紙の本をご注文の際に自動で差し引かれます。',
	conversationPreviewEbookCreditOrderHint: '{credit}のクレジット差し引き · 定価 {fullPrice}',
	conversationPreviewStickyEbookCredit: '{credit}のクレジットを適用',
	paymentMethodEbookCreditHint: '紙の本向けのebookクレジット',
	cartTotalsEbookCredit: 'ebookクレジット',
	cartTotalsCredit: 'クレジット',
	conversationOrderButtonEbook: 'PDFを受け取る',
	conversationOrderButtonEbookWithPrice: 'PDFを受け取る · {price}',
	conversationPreviewTypeBookTaglineSingle: '物語のすべてを、1ページずつ。',
	conversationPreviewTypeBookTaglineMulti: '会話のすべてを{count}冊の本に。',
	conversationPreviewHeroHeading: '本のプレビュー',
	conversationPreviewHelpTourButton: 'ページのヘルプを表示',
	conversationPreviewCardLabelCover: '表紙',
	conversationPreviewCardLabelParticipants: '参加者',
	conversationPreviewCardLabelDates: '日付',
	conversationPreviewCardLabelMessages: 'メッセージ',
	conversationPreviewZoneDone: '確認済み',
	conversationPreviewZoneHintCover: '色、写真、タイトル、まえがき',
	conversationPreviewZoneHintParticipants: '名前と吹き出しの色',
	conversationPreviewZoneHintDates: '本に収録する期間',
	conversationPreviewZoneHintMessages: 'メッセージの非表示や修正',
	conversationHelpPreviewCustomizeTitle: '名前、日付、メッセージ',
	conversationHelpPreviewCustomizeText: 'カードをタップして名前・日付・メッセージを編集できます。',
	conversationBookNavPrev: '前のページ',
	conversationBookNavNext: '次のページ',
	conversationBookBackToCover: '表紙に戻る',
	conversationPreviewTypeBookPagesHint: ' · {pages}ページ',
	conversationPreviewTypeBookMessagesHint: ' · {count}件のメッセージ',
	conversationOrderTotal: '合計',
	conversationPreviewTypeBestofDescription: '400ページ、ベストなやり取りを厳選。電子書籍も無料。',
	conversationPreviewTypeBestofTitle: 'Best Of',
	conversationPreviewTypeBookDescription: '{count}巻 · 全編収録。電子書籍も無料。',
	conversationPreviewTypeBookDescriptionWithPrice: '{count}巻 · {unitBreakdown} · 完全版。電子書籍も無料。',
	conversationPreviewReassuranceShipping: '世界中どこでも配送無料',
	conversationPreviewExpressDeliveryLead: '{where}への速達配送',
	conversationPreviewExpressDeliveryDate: '{date}から',
	conversationPreviewTypeBookTitle: 'コンプリートコレクション',
	conversationPreviewTypeHighlight: 'おすすめ',
	conversationPreviewTypePdfDescription: '会話をPDFで残せます。この金額は、あとで本を選んだときに充当されます。',
	conversationPreviewTypePdfTitle: 'デジタル',
	conversationPreviewTypeSelectionTitle: '形式をお選びください',
	conversationProgress: '進捗',
	conversationProviderButton: '設定を開く',
	conversationProviderType: '種類',
	conversationRemoveButton: '会話を削除',
	conversationRemoveConfirmText: '会話を削除すると、メディアも削除され、元に戻すことはできません。',
	conversationRemoveConfirmTitle: '会話を削除',
	conversationRemoveFlagConfirmMessage: 'この会話からフラグを削除してもよろしいですか？',
	conversationRemoveSuccess: '会話を削除しました。',
	conversationRestartProcess: '再実行',
	conversationResumeButton: '確認して印刷',
	conversationResumeConfirmText: '会話が「確認済み」となり、まもなく生成されて印刷に進みます。',
	conversationValidateModificationsButton: '変更を確定',
	conversationValidateModificationsConfirmTitle: '変更を確定してもよろしいですか？',
	conversationValidateModificationsConfirmBook: '変更内容を反映して、本が再び製造に入ります。',
	conversationValidateModificationsConfirmEbook: '変更内容を反映して電子書籍を再生成し、メールで改めてお送りします。',
	conversationValidateModificationsConfirmMissingMedias: '会話の一部のメディアが見つかりません。確定する前にご確認ください。現在の変更内容のまま本が製造に入ります。',
	conversationValidateModificationsSuccessBook: '変更を保存しました。本は再び製造に入ります。',
	conversationValidateModificationsSuccessEbook: '変更を保存しました。再生成された電子書籍をメールでお送りします。',
	conversationValidateModificationsBackToList: '会話一覧に戻る',
	conversationSelectThread: 'スレッドを選択',
	conversationShareCancelButton: '今はしない',
	conversationShareConfirmButton: '記録を見る',
	conversationShareConfirmTitle: 'こんなものを見つけました...',
	conversationShareConfirmText: '会話には、思わず見入ってしまう数字が隠れています。シェアできる画像にまとめました。',
	conversationStatusConfigured: '生成待ち',
	conversationStatusDone: '完了',
	conversationStatusOngeneration: '生成中',
	conversationStatusOnproduction: '製造中',
	conversationStatusOnvalidation: '印刷待ち',
	conversationStatusPending: '待機中',
	conversationTypeAndroidDownloadAlt: 'またはリンクをコピーして、お好きなブラウザに貼り付けてください',
	conversationTypeAndroidDownloadButton: 'アプリをダウンロード',
	conversationTypeAndroidIntroText1: 'Android スマートフォン（Samsung、HTC、Huawei など）でSMSの本を作るには、お使いのスマートフォンでの操作が必要です。',
	conversationTypeAndroidIntroText2: '次のリンクをクリックして、Android スマートフォンに Mon Livre SMS アプリをインストールしてください（アプリは GooglePlay では提供されていません）',
	conversationTypeAndroidIntroText3: '思い出のSMSの本を一緒につくる相手と、物語の開始日・終了日をお選びください。',
	conversationTypeAndroidIntroText4: '物語の主人公の名前を決め、あらすじを書いて、表紙をカスタマイズしましょう',
	conversationTypeAndroidIntroText5: 'SMSの本を仕上げるには、アカウントを作成し、安全な決済サーバーでお支払いを完了してください。',
	conversationTypeInstagramFileText1: 'Instagram からアーカイブをダウンロードするためのメールが届きます',
	conversationTypeInstagramFileText2: 'お使いの端末にダウンロードしてください',
	conversationTypeInstagramFileText3: '下のボタンをクリックし、アーカイブを開かずに.zipのまま、ファイルの中から選択してください。ファイル名の例：*お名前*_*当日の日付*.zip（選択された会話のみが弊社の印刷サービスに送信されます）',
	conversationTypeInstagramProviderText1: 'アカウントの一般設定から、Instagramのデータのコピーを取得してください',
	conversationTypeInstagramProviderText2: 'Instagramアカウントに登録しているメールアドレスを入力し、形式はJSONを選択してください',
	conversationTypeInstagramProviderText3: '次にパスワードを入力し、<strong>ダウンロードをリクエスト</strong>をクリックすると、Instagram側でバックアップの作成が始まります。',
	conversationTypeIosIntroText1: 'iPhoneをパソコンに接続し、暗号化されていないiTunesバックアップを作成してください。（「このコンピュータ」にチェックを入れ、「iPhoneのバックアップを暗号化」のチェックを外して、「今すぐバックアップ」をクリックします）',
	conversationTypeIosIntroText2: 'お使いのパソコンのOSに対応したリンクをクリックして、MonLivreSMSのソフトウェアをダウンロードしてください：',
	conversationTypeIosIntroText3: '<strong>ご注意：ソフトウェアがバックアップを検出しない場合</strong><br></br> - Macの場合：<br></br>システム環境設定 > セキュリティとプライバシー > フルディスクアクセス を開き、左下の鍵アイコンでロックを解除してから、MonLivreSMSアプリを追加してください。<br></br> - PCの場合： <br></br>Appleはお客様の安全のため、許可なくバックアップを読み取れないようにしています。',
	conversationTypeMessengerFileText1: 'Facebookから、アーカイブをダウンロードするためのメールが届きます',
	conversationTypeMessengerFileText2: 'お使いの端末にダウンロードしてください',
	conversationTypeMessengerFileText3: '下のボタンをクリックし、アーカイブを.zipのまま、ファイルの中から選択してください。例：facebook-*お名前*.zip（選択された会話のみが弊社の印刷サービスに送信されます）',
	conversationTypeMessengerProviderText1: 'アカウントの一般設定から、Facebookのデータのコピーを取得してください',
	conversationTypeMessengerProviderText2: '「情報をダウンロード」をクリックしてください',
	conversationTypeMessengerProviderText3: '次に、以下のオプションを設定してください：<br></br>\n			  <strong>期間</strong>：（お好きな期間）<br></br>\n			  <strong>形式</strong>：JSON<br></br>\n			  <strong>写真の画質</strong>：低（これで十分で、転送時間も短くなります）<br></br>\n			  <strong>情報の種類</strong>：メッセージ（ほかの項目は選択を解除してください）',
	conversationTypeMessengerProviderText4: 'ご注意：データ形式は必ずJSON（HTMLではありません）を選択してください！',
	'conversationTypeSnapchatProviderText1.1': 'お使いの端末でSnapchatアプリを開いてください。',
	'conversationTypeSnapchatProviderText1.2': '画面左上のアバター（またはBitmoji）をタップして、プロフィールを開いてください。',
	'conversationTypeSnapchatProviderText1.3': '右上の歯車アイコンをタップして、設定を開いてください。',
	'conversationTypeSnapchatProviderText2.1': '下にスクロールして「プライバシー」のセクションを表示してください。',
	'conversationTypeSnapchatProviderText2.2': '「マイデータ」を選択してください。',
	'conversationTypeSnapchatProviderText3.1': '本人確認のため、ログインを求められる場合があります。',
	'conversationTypeSnapchatProviderText4.1': '「マイデータ」のページには、ダウンロードできるデータの一覧が表示されます。メッセージもここに含まれています。',
	'conversationTypeSnapchatProviderText4.2': 'ページ下部の「リクエストを送信」をクリックしてください。',
	'conversationTypeSnapchatProviderText5.1': 'リクエストを送信すると、Snapchatがデータのダウンロード準備を進めます。',
	'conversationTypeSnapchatProviderText5.2': '処理には時間がかかることがあり、通常は数時間から1日ほどです。',
	'conversationTypeSnapchatProviderText5.3': 'アーカイブの準備が整うと、データをダウンロードするためのリンクがSnapchatからメールで届きます。',
	'conversationTypeSnapchatProviderText6.1': 'メール内のリンクをクリックして、ダウンロードページを開いてください。',
	'conversationTypeSnapchatProviderText6.2': 'データが入ったZIPファイルをダウンロードしてください。',
	'conversationTypeSnapchatProviderText7.1': 'ZIPファイルをダウンロードしたら、開かないでください。',
	'conversationTypeSnapchatProviderText7.2': 'ZIPファイルはそのままの状態で、指定のエリアにアップロードしてください。',
	'conversationTypeSnapchatProviderText7.3': 'そのあと、本にしたい会話をお選びいただけます。',
	conversationTypeSnapchatProviderTitle1: '1. Snapchatの設定を開く：',
	conversationTypeSnapchatProviderTitle2: '2. データのリクエスト：',
	conversationTypeSnapchatProviderTitle3: '3. 本人確認：',
	conversationTypeSnapchatProviderTitle4: '4. データのダウンロード：',
	conversationTypeSnapchatProviderTitle5: '5. メールの受信を待つ：',
	conversationTypeSnapchatProviderTitle6: '6. アーカイブのダウンロード：',
	conversationTypeSnapchatProviderTitle7: '7. データの取り出しとMonLivreSMSでの利用：',
	'conversationTypeTelegramProviderText1.1': 'https://desktop.telegram.org/ から、パソコン（PCまたはMac）用のTelegramアプリをインストールしてください。',
	'conversationTypeTelegramProviderText1.2': 'パソコンでTelegramアプリを開いてください。',
	'conversationTypeTelegramProviderText2.1': 'アプリ内で、チャット相手の名前をクリックして、本にしたい会話を開いてください。',
	'conversationTypeTelegramProviderText3.1': '会話の右上にある三点アイコンをクリックしてください。',
	'conversationTypeTelegramProviderText3.2': '「チャット履歴をエクスポート」を選択してください。',
	'conversationTypeTelegramProviderText4.1': '設定ウィンドウで、必要なファイルの種類（画像、動画、ボイスメッセージなど）をすべて選択してください。',
	'conversationTypeTelegramProviderText4.2': '必要に応じて、エクスポートするファイルの最大サイズを調整してください。',
	'conversationTypeTelegramProviderText4.3': 'ウィンドウ下部の「エクスポート」をクリックしてください。',
	'conversationTypeTelegramProviderText5.1': 'エクスポートしたデータの保存先を開き、ZIPファイルに圧縮してください（右クリック > 送る > 圧縮（zip形式）フォルダー）。',
	'conversationTypeTelegramProviderText6.1': 'ZIPファイル全体をそのままアップロードしてください',
	conversationTypeTelegramProviderTitle1: '1. パソコン版Telegramアプリのインストール：',
	conversationTypeTelegramProviderTitle2: '2. 会話の選択：',
	conversationTypeTelegramProviderTitle3: '3. 会話履歴のエクスポート：',
	conversationTypeTelegramProviderTitle4: '4. 会話のエクスポート設定：',
	conversationTypeTelegramProviderTitle5: '5. ZIPファイルへの圧縮：',
	conversationTypeTelegramProviderTitle6: '6. MonLivreSMSへのアップロード：',
	conversationTypeTitle: '{name}から本を作る',
	conversationTypeWhatsappFileText1: 'WhatsAppの会話を取得してください',
	conversationTypeWhatsappFileText2: '「ファイルを添付」を選択してください',
	conversationTypeWhatsappFileText3: '会話をダウンロードしてください',
	conversationTypeWhatsappFileText4: 'zip形式でない場合は、圧縮してください',
	conversationTypeWhatsappFileText5: '会話のテキストだけをご希望の場合は、.txtファイルのみをアップロードしてください',
	conversationTypeWhatsappProviderText1: 'WhatsAppの会話のコピーをエクスポート',
	conversationTypeWhatsappProviderText2: '<strong>Androidの場合：</strong><br></br>WhatsAppアプリを開く<br></br>対象の会話を開く<br></br>「オプション」をタップ',
	conversationTypeWhatsappProviderText3: '<strong>iOSの場合：</strong><br></br>WhatsAppアプリを開く<br></br>対象の会話を開く<br></br>メニューバーの連絡先名またはグループ名をタップ<br></br>一番下までスクロールして「チャットをエクスポート」を選択',
	conversations: '会話',
	conversationsMy: '会話一覧',
	conversationBackToList: '会話一覧に戻る',
	conversationsLuxEyebrow: '物語',
	conversationsLuxHint: '会話を選んで、美しい本に仕上げましょう。',
	ordersLuxEyebrow: '工房',
	ordersLuxHint: '本を見つけて、工房からご自宅までの旅を追いましょう。',
	ordersLuxDetailTitle: 'ご注文の本',
	ordersLuxDetailHint: '工房から玄関まで、本の旅を追いましょう。',
	ordersLuxViewFollow: '本を追跡する',
	ordersLuxEmptyTitle: '最初の物語が、あなたを待っています。',
	ordersLuxEmptyHint: '会話を、何度でも開きたくなる一冊に変えましょう。',
	ordersLuxStepReceived: '受付',
	ordersLuxStepAtelier: '工房',
	ordersLuxStepPrint: '印刷',
	ordersLuxStepShipped: '配送中',
	ordersLuxStepHome: 'お手元へ',
	ordersLuxStoryPendingpayment: 'お支払いが完了すると、工房での制作が始まります。',
	ordersLuxStoryPending: 'ご注文を受け付けました。工房ですでに準備を進めています。',
	ordersLuxStoryOnpreparation: '本が形になり始めています。一ページずつ、丁寧に整えています。',
	ordersLuxStoryOnfabrication: '本を印刷しています。まもなく工房を出発します。',
	ordersLuxStoryShipped: '本は配送中です。お手元に向かっています。',
	ordersLuxStoryComplete: '本が届きました。あとは手に取るだけです。',
	ordersLuxStoryCanceled: 'このご注文はキャンセルされました。思い出は大切にお預かりしています。',
	userProfileLuxEyebrow: 'マイページ',
	userProfileLuxHint: '登録情報、ログイン方法、設定を管理できます。',
	userProfileValueEmpty: '未設定',
	userProfileNotLinked: '未連携',
	userProfileNewsletterOn: 'すでにニュースとお得情報をお届けしています。',
	userProfilePasswordOn: '設定済み',
	addressesLuxEyebrow: 'ご住所',
	addressesLuxHint: '配送先と請求先の住所を確認できます。',
	addressesLuxEditHint: 'この住所は配送または請求に使えます。',
	conversationsNewApp: 'アプリの新しい会話',
	conversationsOldApp: 'アプリの以前の会話',
	dashboardTitle: 'ダッシュボード',
	date: '日付',
	dateActivated: '有効化日',
	dateCreated: '作成日',
	dateLastCguAccept: '利用規約の最終同意日',
	dateLastEdit: '最終更新日',
	dateLastLogin: '最終ログイン日',
	dateSelect: '日付を選択',
	dateSelectPlaceholder: 'クリックして日付を選択...',
	dateStatus: 'ステータス更新日',
	dateValidation: '確定日',
	dates: '日付',
	days: '日数',
	daysCount: '{count}{count, plural,\n		=0 {日}\n		=1 {日}\n		other {日}\n	}',
	delete: '削除',
	deleteRequestError: '削除できませんでした。',
	deleteRequestSuccess: '削除しました。',
	description: '説明',
	detailsInformation: '詳細',
	domain: 'ドメイン',
	download: 'ダウンロード',
	edit: '編集',
	editViewAdvanced: '詳細編集',
	editViewSimplified: 'かんたん編集',
	elementNoItems: '項目がありません',
	elementsCount: '{count}{count, plural,\n			  =0 {件}\n			  =1 {件}\n			  other {件}\n		  }',
	example: '例',
	examples: '例',
	file: 'ファイル',
	fileDeleteError: 'このファイルを削除できませんでした。',
	fileDeleteSuccess: 'ファイルを削除しました。',
	fileSelected: '選択したファイル：{file}',
	fileSwitch: 'ファイルを変更',
	fileUploadError: 'このファイルをアップロードできませんでした。',
	fileUploadProcessStartOnSave: 'ファイルのアップロードは保存時に開始されます。',
	fileUploadRestrictionTypeError: '対応していないファイル形式です。利用できる形式：{types}',
	fileUploadSuccess: 'ファイルをアップロードしました。',
	files: 'ファイル',
	filtersTitle: '絞り込み',
	finish: '完了',
	flags: 'フラグ',
	free: '無料',
	generalInformation: '基本情報',
	help: 'ヘルプ',
	hours: '時間',
	hoursCount: '{count}{count, plural,\n		=0 {時間}\n		=1 {時間}\n		other {時間}\n	}',
	imageDeleteError: 'この画像を削除できませんでした。',
	imageDeleteSuccess: '画像を削除しました。',
	imageUploadError: 'この画像をアップロードできませんでした。',
	imageUploadRestrictionSize: '画像は最大{format}までです',
	imageUploadRestrictionType: '画像の形式は{types}にしてください',
	imageUploadRestrictionTypeError: '対応していない画像形式です。利用できる形式：{types}',
	import: 'インポート',
	importModelDownloadButton: 'テンプレートをダウンロード',
	importRequestError: 'インポート中にエラーが発生しました。',
	importRequestSomeFailAlert: '一部のデータをインポートできませんでした。',
	importRequestSuccess: 'データをインポートしました。',
	identifier: '識別子',
	importerFileButton: 'データをインポート',
	importerFileHelp: 'CSVファイルは、表計算ソフト（Excel、OpenOfficeなど）で作成できます',
	importerFileInfo: 'CSVファイル（カンマ区切り）を選択してください',
	importerNoItemsAlert: 'インポートする項目がありません',
	importerTitle: 'データのインポート',
	information: '情報',
	informationsDetails: '詳細',
	informationsGeneral: '基本情報',
	invoicePrint: '請求書を印刷',
	invoicesPrint: '請求書をまとめて印刷',
	isActive: '有効',
	isPublic: '公開',
	isUnlimited: '無制限',
	label: '名称',
	language: '言語',
	languageAR: 'アラビア語',
	languageBN: 'ベンガル語',
	languageDE: 'ドイツ語',
	languageEN: '英語',
	languageES: 'スペイン語',
	languageFR: 'フランス語',
	languageHI: 'ヒンディー語',
	languageIT: 'イタリア語',
	languageJA: '日本語',
	languagePT: 'ポルトガル語',
	languageRU: 'ロシア語',
	languageZH: '中国語',
	learnMoreButton: '詳しく見る',
	limitLabel: '制限の種類',
	limitTextForm1: 'には次が必要です',
	listTitle: '一覧',
	loading: '読み込み中...',
	loadMore: 'さらに読み込む…',
	copiedToClipboard: 'コピーしました！',
	logo: 'ロゴ',
	minutes: '分',
	name: '名前',
	next: '次へ',
	no: 'いいえ',
	of: '/',
	options: 'オプション',
	order: 'ご注文',
	orderAdd: '注文を追加',
	orderAddTitle: '注文を追加',
	orderAddressPrivacyInfo: 'お客様の住所が公開されることはありません！このご注文の他の参加者のみが閲覧できます。',
	orderAddressShippingValid: '配送先住所を確定',
	orderBilling: '請求情報',
	orderConfirmationPaymentError: 'エラーが発生しました……お手数ですが、お問い合わせください！',
	orderConfirmationPaymentWaiting: '少々お待ちください……ご注文を確定するため、お支払いを処理しています',
	orderConfirmationPaymentWaitingHint: '通常は数秒で完了します。',
	orderConfirmationPendingText: 'ご注文の完了にはお支払いが必要です！下のリンクをクリックし、お支払いを確定してご注文を完了してください。',
	orderConfirmationPendingText2: 'ご注意：クレジットカードでお支払いの場合、決済の承認にお時間がかかることがあります。確認が完了するまで少々お待ちください。',
	orderConfirmationPendingTitle: 'お支払い待ちのご注文です！',
	orderConfirmationOrderNumber: 'ご注文番号 {code}',
	orderConfirmationNextStepsTitle: 'この後の流れ',
	orderConfirmationStepEmail: '確認メール',
	orderConfirmationStepEmailDesc: '{email} にご注文内容をお送りしました',
	orderConfirmationStepEmailDescNoEmail: 'ご注文内容をメールでお送りします',
	orderConfirmationStepPreparation: '本の制作',
	orderConfirmationStepPreparationDesc: '心を込めて印刷・製本いたします',
	orderConfirmationStepShipping: '発送',
	orderConfirmationStepShippingDesc: '商品の発送後、すぐにメールでお知らせします',
	orderConfirmationSummaryTitle: 'ご注文内容',
	orderConfirmationViewOrderCta: 'ご注文状況を確認',
	orderConfirmationHomeCta: 'ホームに戻る',
	orderConfirmationGuestTitle: '最新情報をお届けします',
	orderConfirmationSocialText: 'お気に入りのSNSでフォローして、最新ニュースや新商品、お得な割引情報をチェックしてください……',
	orderConfirmationSocialTitle: 'ぜひつながりましょう！',
	orderConfirmationText: 'ご注文を承りました。これから準備を進めます。発送の際にはメールでお知らせします。',
	orderConfirmationTitle: '承りました！',
	orderContent: 'ご注文の内容',
	orderDetails: '詳細',
	orderId: 'ID',
	orderInfoCommentAlertTitle: '重要なお知らせ',
	orderInvoice: '請求書',
	orderInvoicePrintButton: '請求書を印刷',
	orderItemsEmpty: 'ご注文に商品がありません',
	orderItemViewBook: '本を見る',
	orderItemsTotal: '商品合計：',
	orderMassStatusConfirmMessage: '{count}件の注文のステータスを更新しますか？',
	orderMassExportInvoiceDetails: '請求書の明細をエクスポート',
	orderMassUpdateStatus: 'ステータスを更新',
	orderMassSendEmail: 'メールを送信',
	orderAdminListHint: 'ステータス別に注文を追跡・処理できます。フィルターを使って、国・商品・確定日で絞り込めます。',
	orderNoItems: 'まだご注文がありません！',
	orderFlags: 'フラグ',
	orderNote: 'メモ',
	orderNoteCustomer: 'お客様のメモ',
	orderNoteAdmin: '内部メモ（管理者）',
	orderNoteAdminAdd: 'メモを追加',
	orderNoteAdminEmpty: 'この注文に内部メモはありません。',
	orderNoteAdminPlaceholder: 'チーム内のみに表示される内部メモ（発送、サポートなど）',
	orderPaymentChooseMethodLabel: 'お支払い方法を選択',
	orderPaymentFinishTitle: 'お支払いの完了',
	orderPaymentValidButton: 'お支払いを確定',
	orderPaymentMethod: 'お支払い方法',
	orderPayments: 'お支払い',
	orderProcessInvitationText: '友だちを招待して枠を埋めましょう',
	orderProcessInvitationTextBefore1: 'Directos.eu は個人同士の共同購入サービスです。メーカーから直接商品を購入できるので、商品価格と配送料の両方を節約できます！',
	orderProcessInvitationTextBefore2: 'ご心配なく！解決策があります：',
	orderPublicAccess: '公開アクセス',
	orderProductAdd: '商品を追加',
	orderRefunds: '返金',
	orderShipping: '配送',
	orderShippingAdd: '配送を追加',
	orderSendStatusNotificationEmail: '通知メールを送信',
	orderShippingFee: '配送料',
	orderShippingRemoveConfirmMessage: 'この配送を注文から削除してもよろしいですか？',
	orderShippingTrackingTitle: 'ご注文の配送状況',
	orderShippingTrackingButton: '荷物を追跡',
	orderShippingTrackingHint: '追跡情報は運送会社側で数時間かかる場合があります。',
	orderShippings: '発送',
	orderStatus: 'ステータス',
	orderStatusCanceled: 'キャンセル済み',
	orderStatusComplete: '完了',
	orderStatusOnpreparation: '準備中',
	orderStatusOnprogress: '処理中',
	orderStatusPending: '保留中',
	orderStatusPendingpayment: 'お支払い待ち',
	orderStatusShipped: '発送済み',
	orderSubtotalDiscount: '割引',
	orderSubtotalExclTax: '小計（税抜）',
	orderSubtotalInclTax: '小計（税込）',
	orderTax: '消費税',
	orderThanks: 'ご注文ありがとうございます',
	attributionPaidLine: 'お支払いが完了しました',
	attributionSkip: '注文を見る',
	attributionSourceTitle: 'この本が欲しくなったきっかけは何ですか？',
	attributionSourceLead: 'ご注文はすでに受け付けています。心に残ったことを、一つだけ教えてください。',
	attributionSearchTitle: '検索する前から、MonLivreSMSをご存知でしたか？',
	attributionSearchLead: 'どこかで聞いた名前か、初めて知った名前か。',
	attributionOccasionTitle: 'この本は、どんなときのためのものですか？',
	attributionOccasionLead: '思い浮かんでいる、そのとき。',
	attributionOtherPlaceholder: 'よろしければ、ひと言どうぞ',
	attributionOtherContinue: '続ける',
	attributionSaveError: '回答を保存できませんでした。もう一度お試しください。',
	attributionOpt_bouche_a_oreille: '身近な人から聞きました',
	attributionOpt_vu_objet: '誰かの家で、本を見ました',
	attributionOpt_receveur_devenu_client: 'もらったので、今度は自分の番です',
	attributionOpt_recherche: 'Googleで探して',
	attributionOpt_instagram: 'Instagram',
	attributionOpt_tiktok: 'TikTok',
	attributionOpt_facebook: 'Facebook',
	attributionOpt_pinterest: 'Pinterest',
	attributionOpt_qvema: 'Qui veut être mon associé',
	attributionOpt_medias: '記事、番組、ポッドキャスト',
	attributionOpt_client_existant: 'ここで注文したことがあります',
	attributionOpt_autre: '別のこと',
	attributionOpt_decouverte_pure: 'どちらかといえば偶然',
	attributionOpt_pre_bao: '身近な人から聞いていました',
	attributionOpt_pre_tv: 'テレビで見たことがありました',
	attributionOpt_pre_social: 'SNSで見たことがありました',
	attributionOpt_pre_inconnu: 'よく覚えていません',
	attributionOpt_anniv_couple: '出会った日の記念',
	attributionOpt_noel: 'クリスマス',
	attributionOpt_saint_valentin: 'バレンタイン',
	attributionOpt_anniversaire: '誕生日',
	attributionOpt_deuil: '失った人のメッセージ',
	attributionOpt_naissance: '誕生',
	attributionOpt_distance: '離れていく人、または遠くにいる人',
	attributionOpt_pour_soi: '自分のため、贈り物ではなく',
	attributionOpt_autre_occasion: '別の瞬間',
	bookIntentTitle: 'この本は、どんなときのためですか？',
	bookIntentLead: 'ひとつ選んだら、始められます。',
	bookIntentSkip: '今はしない',
	bookIntentOpt_anniv_couple: '出会った日の記念',
	bookIntentOpt_anniversaire: '誰かの誕生日',
	bookIntentOpt_noel: 'クリスマス',
	bookIntentOpt_saint_valentin: 'バレンタイン',
	bookIntentOpt_souvenir: 'もういない人のために',
	bookIntentOpt_plus_tard: 'もう少し先の日',
	bookIntentOpt_autre: '別のとき',
	bookIntentDate_anniv_couple: 'その日はいつですか',
	bookIntentDateLead_anniv_couple: '出会った日、またはお二人が祝う日。',
	bookIntentDate_anniversaire: 'お誕生日は何日ですか',
	bookIntentDateLead_anniversaire: '贈る相手の誕生日です。',
	bookIntentDate_plus_tard: 'いつ頃ですか',
	bookIntentDateLead_plus_tard: '思い浮かんでいる日。',
	bookIntentDateDefer: '日付はあとで',
	bookIntentDateBack: '戻る',
	bookIntentDateContinue: '続ける',
	bookIntentSaveError: '回答を保存できませんでした。もう一度お試しください。',
	inboxPromptTitle: '本のために',
	inboxPromptSignup: 'メールをお送りしました。「{subject}」です。本のはじまりであって、宣伝ではありません。{provider}が別の場所に置くことがあります。「{mark}」にしてください。そのひとことで、続きがきちんと届き、本をちゃんと作るためのものが手元にそろいます。',
	inboxPromptTransfer: 'メールをお送りしました。「{subject}」です。会話へのリンクであって、宣伝ではありません。{provider}が別の場所に置くことがあります。「{mark}」にしてください。そのひとことで、望む本にするためのものが手元にそろいます。',
	inboxPromptMarkGmail: '迷惑メールではない',
	inboxPromptMarkYahoo: '迷惑メールではない',
	inboxPromptButton: '{provider}で確認する',
	inboxPromptClose: '閉じる',
	inboxPromptConfirm: 'メールをお送りしました。「{subject}」です。アカウントを開くためのものです。{provider}が別の場所に置くことがあります。「{mark}」にしてください。そのひとことで、続きが届きます。',
	emailConfirmPageTitle: 'メールアドレスの確認',
	emailConfirmTitle: 'メールをご確認ください',
	emailConfirmLead: 'アカウントを開くメールをお送りしました。中のボタンでアドレスを確認できます。',
	emailConfirmResend: 'メールを再送する',
	emailConfirmResent: 'メールを再送しました。',
	emailConfirmExpired: 'このリンクの期限が切れています。アカウントから新しいリンクを依頼してください。',
	emailConfirmInvalid: 'このリンクに対応するアカウントはありません。',
	emailConfirmWorking: 'アカウントを開いています…',
	orderTotal: '合計',
	orderTotalTTC: '合計（税込）',
	orderTotalTax: '消費税 {rate}%',
	orderTotalToPay: 'お支払い総額：{total}€',
	orderTotals: '合計金額',
	orderUserRegisterAlert: 'ご注文に問題があった際にご連絡できるよう、メールアドレスをご入力ください。',
	orderView: 'ご注文を見る',
	orderViewShort: 'ご注文',
	orderWeight: '重量',
	orderWeightHint: '合計 = 単価重量 × 数量（{quantity}点 → {weight} kg）',
	orderWeightHintPages: 'ページ数からの目安（{grams} g/ページ）：{pages}ページ → {weight} kg',
	orderShippingManualFlag: '契約中の配送業者では、この配送先（国・重量・受取店舗）に対応できません。下のSendcloud方法を選び、ラベルを生成してください。',
	shippingLegacyChronopostPaused: 'この注文は以前のChronopostのままです。編集から配送方法をSendcloudのオファーに変えて、ラベルを作成してください。',
	orderShippingFedexPickupFlag: 'FedEx発送：集荷はパリ時間18時〜21時の間に、翌営業日分として自動予約されます。',
	orderShippingFedexPickupBookedFlag: 'FedEx集荷を{date}に予約しました（Sendcloud n°{id}）。',
	orderitemAddProductTitle: '商品情報を編集',
	orders: '注文',
	ordersEditSuccess: '注文を更新しました！',
	ordersContactTitle: '注文から連絡する',
	ordersMy: 'ご注文履歴',
	ordersMyViewButton: 'ご注文履歴を見る',
	packingInformation: '梱包情報',
	parcelGroupInfo: '荷物の個数でまとめる',
	parcelGroupLabel: '荷物グループ',
	parcelGroupWeightInfo: '荷物グループあたりのkg',
	parcelGroupWeightLabel: '重量で荷物をまとめる',
	paymentCardInputLabel: 'ご注文を確定するため、クレジットカード情報をご入力ください。',
	paymentMethodCreditbalanceDescription1: '合計から自動で差し引かれます',
	paymentMethodCreditbalanceDescription2: 'お支払い残額',
	paymentMethodCreditbalancePay: 'クレジットで確定する',
	paymentMethodCreditbalanceTitle: 'クレジット適用済み',
	paymentFailError: 'お支払いが完了しませんでした！もう一度お試しください',
	paymentMethod: 'お支払い方法',
	paymentMethodBancontactLabel: 'Bancontact',
	paymentMethodBankcheckLabel: '銀行小切手',
	paymentMethodBanktransferLabel: '銀行振込',
	paymentMethodCardLabel: 'クレジットカード',
	paymentMethodCreditcardLabel: 'クレジットカード',
	paymentMethodCreditDescription1: 'この金額は、カートの合計金額のうちお支払い残額から自動的に差し引かれます。',
	paymentMethodGiropayLabel: 'Giropay',
	paymentMethodIdealLabel: 'iDEAL',
	paymentMethodPhoneLabel: '電話',
	paymentMethodCreditPay: '保有クレジットでお支払い',
	paymentMethodCreditTitle: 'ご注文の一部は、すでにお支払い済みです：',
	paymentValidButton: 'お支払いを確定',
	previous: '戻る',
	priceInformation: '価格情報',
	priceRoundAlertTooltip: '通貨換算のため、価格が端数処理される場合があります',
	printButton: '印刷',
	process: 'プロセス',
	productAnnexes: '付録',
	productAnnexesNewProductError: '付録を追加する前に、新しい商品を保存してください！',
	productAttributes: '属性',
	product: '商品',
	productAdd: '商品を追加',
	productAdminListHint: '商品カタログ、価格、ショップでの販売状況を管理できます。',
	productConversationTypeMissingAlert: '選択された種類に対応する商品がありません。お手数ですが、お問い合わせください！',
	productCostHT: '原価（税抜）',
	productDescription: '説明',
	productEdit: '商品を編集',
	productImages: '画像',
	productImagesNewProductError: '画像を追加する前に、新しい商品を保存してください！',
	productIsActive: '有効',
	productName: '名前',
	productPictureDelete: '画像を削除',
	productPriceHT: '価格（税抜）',
	productPriceTTC: '価格（税込）',
	productReference: '品番',
	productSlug: 'スラッグ',
	productSpecialPriceQuantityDiscountInfo: '{quantity}冊追加すると、カートが{percent}%お得になります！',
	productTaxCalculate: '計算',
	productTaxRate: '税率',
	productTaxRateFormHelp: '税率20%の場合は、税率に0.2と入力してください',
	productUseForConversationBook: '紙の本に使用しますか？',
	productUseForConversationEBook: '電子書籍に使用しますか？',
	productUseForCredit: 'ユーザークレジットに使用しますか？',
	products: '商品',
	productsView: '商品を見る',
	quantity: '数量',
	refresh: '更新',
	refundCreateTitle: '返金を作成',
	refundCreateConfirmMessage: 'この返金を作成してもよろしいですか？',
	remove: '削除',
	retry: 'やり直す',
	save: '保存',
	saveBeforeAlert: '先に保存してください...',
	saveRequestError: '保存できませんでした！',
	saveRequestSuccess: '保存しました！',
	saving: '保存中...',
	searchFor: '検索',
	seconds: '秒',
	select: '選択',
	selectAll: 'すべて選択',
	selectFile: 'ファイルを選択',
	selectImage: '画像を選択',
	selectOptions: 'オプションを選択',
	selectUnAll: 'すべて選択解除',
	seoOrderViewTitle: 'ご注文番号{code}',
	seoTitle: 'SMSや会話を本に印刷',
	shippingAddressEdit: '配送先住所を変更',
	shippingAddressMissingError: '配送先住所が入力されていません。',
	shippingCalculation: '計算',
	shippingCalculationInfo: '計算がループする場合は、上限を含む最大値を使用することをおすすめします。',
	shippingCarrier: '配送業者',
	shippingChronopostPickupError: '受取店舗を取得できませんでした。国と郵便番号をご確認のうえ、もう一度お試しください。',
	shippingChronopostPickupNoResult: 'お近くの受取店舗が見つかりませんでした。別の住所で検索してください。',
	shippingChronopostPickupOpeningHours: '営業時間',
	shippingChronopostPickupOpeningHoursView: '営業時間を見る',
	shippingChronopostPickupViewList: 'リストを見る',
	shippingChronopostPickupViewMap: '地図を見る',
	shippingPickupError: '受取店舗の選択画面を開けませんでした。しばらくしてからもう一度お試しください。',
	shippingPickupChange: '受取店舗を変更',
	shippingPickupChoose: '受取店舗を選択',
	shippingPickupSelectedHint: '受取店舗を選びました。お会計を続けられます。',
	shippingPickupSelectedLabel: '受取店舗',
	shippingPickupMapUnavailable: 'これらの受取店舗は地図を表示できません。リスト表示をご利用ください。',
	shippingPickupNoResultHomeHint: 'この住所の近くに受取店舗がありません。別の郵便番号を試すか、上の自宅配送をお選びください。',
	shippingPickupErrorHomeHint: '受取店舗を読み込めませんでした。再試行するか、上の自宅配送をお選びください。',
	shippingDeliveryApproxOn: '{date}ごろ',
	shippingDeliveryApproxBetween: '{date1}から{date2}の間',
	shippingCountrySelect: '配送先の国',
	shippingDeleteConfirmMessage: 'この配送方法を削除してもよろしいですか？',
	shippingDeliveryEstimationDate1: '配送予定日：{date}',
	shippingDeliveryEstimationDate2: '配送予定日：{date1}から{date2}の間',
	shippingDeliveryEstimationText: 'こちらは配送料の目安です。お届け先の選択は次のステップで行います。',
	shippingSurchargeCorsica: 'この料金にはコルシカ島向けの追加料金 {price} が含まれます。',
	shippingSurchargeOverseas: 'この料金には海外領土向けの追加料金 {price} が含まれます。',
	shippingSurchargeRemote: 'この料金には配送困難地域向けの追加料金 {price} が含まれます。',
	shippingDeliveryTime: '配送日数（日）',
	shippingDeliveryTimeInfo: '{days}営業日でお届け',
	shippingDescription: '説明',
	shippingExcludeDepartmentInfo: '除外する郵便番号はカンマ（,）で区切ってください。ワイルドカードには「*」を使用します。',
	shippingExcludeDepartmentLabel: '郵便番号を除外',
	shippingExtraFeeCalculation: '追加配送料の計算',
	shippingExtraFeeLabel: '追加配送料のラベル',
	shippingExtraFees: '追加料金',
	shippingFeeCalculatorTitle: '配送料を計算する',
	shippingFeeFreeDelivery: '送料無料',
	shippingFeeNotFoundError: '',
	shippingFeeWithBookResult: '今すぐご注文いただくと、電子書籍は数分で、紙の本は{countryName}へ{deliveryDateFrom}から{deliveryDateTo}の間にお届けします。',
	shippingFeeWithoutBookResult: '今すぐご注文いただくと、電子書籍を数分でお届けします。',
	shippingFreeStep: '送料無料のステップ',
	shippingFreeTreshold: '送料無料のしきい値',
	shippingFreeInfo: '{value}以上で送料無料',
	shippingIdentifier: '配送ID',
	shippingIsPriceTTC: '配送料に消費税は含まれていますか？',
	shippingLabelGenerateButton: 'ラベルを生成',
	shippingLabelGenerateButton2: 'ラベルを再生成',
	packingCheckTitle: 'この注文の本',
	packingCheckHint: '本を1冊ずつ、裏表紙をカメラに向けてください。数字が進んだら、本を画面の外に置き、次の本へ進んでください。',
	packingCheckProgress: '{seen} / {expected}',
	packingCheckForeign: 'この本は注文{code}のものです。荷物から出してください。',
	packingCheckReady: '確認できました。この注文の本です。ラベルを印刷できます。',
	packingCheckOverflow: '読み取った本が多すぎます。最初からやり直してください。',
	packingCheckRestart: 'やり直す',
	packingCheckCameraStart: 'カメラを開く',
	packingCheckCameraDenied: 'カメラがブロックされています。許可するか、スキャナーでQRを読み取ってください。',
	packingCheckLocked: 'ラベルを印刷する前に、すべての本をスキャンしてください。',
	packingCheckWedgeLabel: 'またはスキャナーでQRを読み取る',
	packingCheckLoading: 'この注文の本を読み込んでいます。',
	prepBooksCardTitle: '本',
	prepBooksCount: '{count}冊',
	prepBooksPageEyebrow: '準備',
	prepBooksPageTitle: '注文{code}',
	prepBooksPageHint: 'この荷物に入る本です。',
	prepModeClient: 'お客様画面',
	prepModePreparation: '準備画面',
	shippingLabelGenerateError: 'ラベルを作成できませんでした。住所、受取店舗、Sendcloudの認証情報を確認してから、もう一度お試しください。',
	shippingProviderSendcloudInfoDefault: '自宅配送。製作は約2営業日（月〜金、フランスの祝日を除く）のあと、運送会社へ渡します。最終の運送会社はラベル作成時に決まります。',
	shippingProviderSendcloudPickupInfoDefault: '近くの受取店舗をお選びください。製作は約2営業日（月〜金、フランスの祝日を除く）のあと発送します。最終の運送会社はラベル作成時に決まります。',
	shippingSendcloudMethodAuto: '自動（最適な方法）',
	shippingSendcloudMethodOverride: 'Sendcloud運送会社（ラベル）',
	shippingSendcloudMethodOverrideHint: '自動のままにするか、ラベル生成前に別のSendcloud方法を指定できます。',
	shippingSendcloudPickLog: '使用したSendcloud方法',
	shippingAdd: '配送方法を追加',
	shippingAdminListHint: '配送業者、対象国、料金ルールを設定します。',
	shippingMethod: '配送方法',
	shippingMethodCalculating: '配送料を計算中...',
	shippingMethodConditions: '配送条件',
	shippingMethodMissingAlert: 'お客様のカートに対応する配送業者が見つかりません。配送内容を変更して配送業者を選択してください。',
	shippingMethodNotAvailable: 'ご入力の住所に対応する配送方法がありません...',
	shippingRatesError: '配送料の計算が途中で止まりました。少し時間をおいて、もう一度お試しください。それでも続く場合はお問い合わせください。一緒に確認いたします。',
	shippingMethodPricing: '料金',
	shippingMethodPricingSystem: '料金体系',
	shippingMethodSearch: '配送方法を検索中',
	shippingMethodSelectTitle: '配送方法を選択してください',
	shippingGroupRelay: '受取店舗',
	shippingGroupHome: '自宅配送',
	shippingTierClassic: '通常配送',
	shippingTierExpress: '速達配送',
	shippingTierClassicDesc: '標準的なお届け日数',
	shippingTierExpressDesc: '最も早いオプション',
	shippingTierPriceRelayFree: '受取店舗は無料',
	shippingTierPriceRelayFrom: '受取店舗 {price} から',
	shippingTierPriceHomeFrom: '自宅配送 {price}',
	shippingChangeTier: '配送速度を変更',
	shippingTierModeTitle: '配送方法を選択',
	shippingStepOf: 'ステップ {current} / {total}',
	shippingStepSpeedTitle: 'いつお届けしますか？',
	shippingStepModeTitle: 'どこにお届けしますか？',
	shippingMethodTrackingInfo: '追跡情報',
	shippingMethods: '配送方法',
	shippingOrder: '表示順',
	shippingProvider: '配送プロバイダー',
	shippingStep: 'ステップ',
	shippingStepInfo: 'このステップは必ず左側の設定にしてください。上の設定がデフォルトの郵便番号です。',
	shippingStepLimitInfo: '左の条件は最小値／最大値ですか？',
	shippingTaxRate: '配送料の消費税率',
	shippingTitle: '配送',
	shippingTrackingNumber: '追跡番号',
	shippingTrackingParcelUrl: '配送追跡ページのURL',
	status: 'ステータス',
	stepTitle: 'ステップ{step}',
	submit: '送信',
	suborderitemAddProductTitle: '商品を追加',
	switchLanguage: '言語を変更',
	tableDownloadNoElementError: 'ダウンロードできる項目がありません！',
	tablePageSize: '表示件数',
	tableMassActions: '一括操作',
	tableRefreshSuccessAlert: '同期しました！',
	tableRefreshSuccessError: '同期できませんでした！',
	tableSelection: '{count} {count, plural,\n			  =0 {件を選択中}\n			  =1 {件を選択中}\n			  other {件を選択中}\n		  }',
	tag: 'キーワード',
	tagFillPlaceholder: 'キーワードを入力してください...',
	tags: 'キーワード',
	taskDescription: '説明',
	taskAddTitle: 'タスクを追加',
	taskEditTitle: 'タスクを編集',
	taskCountdownDate: 'リマインダーの日付',
	taskAssignSelf: '自分に割り当て',
	taskPriority: '優先度',
	taxRate: '消費税',
	the: '',
	time: '時刻',
	timezone: 'タイムゾーン',
	title: 'タイトル',
	toleranceLabel: '許容範囲',
	total: '合計',
	type: '種類',
	unit: '単位',
	user: 'ユーザー',
	userAccountCreditsTitle: 'クレジット残高',
	userAccountDataProtection: 'データ保護',
	userAccountDataProtectionText1: 'お客様の個人情報の保護を非常に重視しています。そのため、データを安全に管理し、サービスを適切にご提供するために必要かつ合理的な期間のみ保管しています。',
	userAccountDataProtectionText2: 'サービスのご提供に必要な情報のみをお伺いしています。お客様の同意なく第三者のサービスに提供したり、商業目的で個人情報を利用したりすることは一切ありません。',
	userAccountDataProtectionText3: 'データの取得やデータポータビリティの権利の行使をご希望の場合は、{email}までご連絡ください。',
	userAccountDelete: 'アカウントを削除',
	userAccountDeleteActiveSuborder: 'ご参加中のご注文が完了するまで、アカウントを削除できません！',
	userAccountDeleteBlockText: '現在アカウントを削除できません！',
	userAccountDeleteButton: 'アカウントを削除',
	userAccountDeleteConfirmMessage: 'アカウントを完全に削除してもよろしいですか？',
	userAccountDeleteConfirmTitle: 'アカウントを削除',
	userAccountDeleteError: 'アカウントを削除できませんでした！',
	userAccountDeleteSuccess: 'アカウントを削除しました！またのご利用をお待ちしています！',
	userAccountDeleteText: 'アカウントを削除すると、本サイト上のお客様の情報にアクセスできなくなります。当社のデータベースからお客様の個人情報を削除します。この操作は取り消せません！',
	userAccountEdit: 'アカウントを編集',
	userAccountEditSuccess: 'アカウントを更新しました',
	userAccountExistError: 'このメールアドレスに紐づくアカウントがありません！',
	userAccountExistTitle: 'すでにアカウントをお持ちですか？',
	userAccountGeneral: '一般',
	userAccountHistory: '履歴',
	userAccountInfo: 'お客様のデータは保護され、厳重に管理されます。',
	userAccountInfoMyTitle: '登録情報',
	userAccountMy: 'マイアカウント',
	userAccountNote: 'ユーザーアカウントのメモ',
	userAccountPersonnalInformation: '個人情報',
	userAccountPreferencesInformation: '設定',
	userAccountResetError: 'アカウントをリセットできませんでした！',
	userAccountResetSuccess: 'アカウントをリセットしました！',
	userActivityOnLine: 'オンライン',
	userAdd: 'ユーザーを追加',
	userAddNew: '新しいユーザーを追加',
	userAdminListHint: 'アカウントを検索し、アクティビティを確認して、ユーザーのプロフィールや注文を開けます。',
	userBridgeError: 'アプリからのログインに失敗しました。もう一度お試しください。',
	userBridgeInvalid: 'このログインリンクは無効です。アプリからやり直してください。',
	userBridgePending: 'ログインしています…',
	userBridgeSuccess: 'ログインしました！アプリに戻ってください。',
	userChangePasswordSuccess: 'パスワードを変更しました！',
	userConfirmationCode: 'メールで受け取った確認コード',
	userConfirmationCodeCheckButton: 'パスワード再設定用のコードを受け取りました',
	userConfirmationCodeError: '確認コードを入力してください！メールボックスをご確認ください！',
	userConnectionInfo: 'アカウントにログインしてご注文を確定し、お友達を招待しましょう！',
	userCredits: 'クレジット',
	userCreditsBalancePositive: '{amount}のクレジットをご利用いただけます：次のステップで自動的に適用されます。',
	userCreditsPrepaymentInviteTitle: '本の事前お支払い',
	userDeleteConfirmTitle: 'ユーザーを削除',
	userDeleteConfirmMessage: 'このユーザーを削除してもよろしいですか？',
	userDeleteConfirmation: '{user}を削除しました！',
	userEdit: '{user}を編集',
	userEdit2: 'ユーザーを編集',
	userEditPassword: 'パスワードを変更',
	userEmail: 'メールアドレス',
	userEmailError: 'メールアドレスが正しくありません！',
	userEmailFillInfo: 'メールアドレスを入力してください',
	userEmailFormInfo: '続けるにはメールアドレスを入力してください',
	userEmailFormInfo2: 'メールアドレスはアカウントの作成と、ご注文の更新のお知らせに使用します。',
	userLoginCodeTitle: 'すでにアカウントをお持ちです',
	userLoginCodeIntro: '{email} 宛てに6桁のコードをお送りしました。続けるには、こちらにコードを入力してください。',
	userLoginCodeLabel: 'メールに記載されたコード',
	userLoginCodeSubmit: '確認する',
	userLoginCodeInvalid: 'コードが一致しません。最新のメールをご確認ください。',
	userLoginCodeExpired: 'このコードは無効になりました。下から新しいコードをお申し込みください。',
	userLoginCodeError: '申し訳ございません、うまくいきませんでした。しばらくしてからもう一度お試しください。',
	userLoginCodeLinkHint: '同じメールにログイン用リンクも記載しています。',
	userLoginCodeResend: '新しいコードを送る',
	userLoginCodeResendIn: '{seconds}秒後に新しいコードを送れます',
	userLoginCodeResent: '再送しました。迷惑メールフォルダもご確認ください。',
	userLoginCodeChangeEmail: '別のメールアドレスを使う',
	userLoginCodeCartSuccess: 'ログインしました。このままご注文を完了いただけます。',
	userEnvironmentTestNoTest: 'このユーザーは環境テストを受けていません！',
	userFillPlaceholder: 'ユーザー名を入力してください...',
	userFirstName: '名',
	userForgotPassword: 'パスワードをお忘れですか？',
	userForgotPasswordRetryDateError: 'パスワードの再発行を再度リクエストすることはできません。確認コードはメールボックスでご確認ください。',
	userFormInfo: 'プロフィールを入力してください',
	userGenderLabel: '性別',
	userIsActive: '有効',
	userLastName: '姓',
	userLogin: 'ログイン',
	userLoginAction: 'ログイン',
	userLoginEmailSelected: 'このメールアドレスでログイン：{email}',
	userLoginError: 'ログイン情報が正しくありません。もう一度お試しください。',
	userLoginFirstButton: '初めてのログインですか？',
	userLoginFirstText: '仮パスワードはメールボックスでご確認ください。初回のログインにはこのパスワードをご利用ください。ログイン後にパスワードを変更していただけます。',
	userLoginBenefit1: '数クリックでSMSのフォトブックが完成',
	userLoginBenefit2: 'ご自宅へスピード配送',
	userLoginBenefit3: '100%安全なお支払い',
	userLoginIntro: 'マイページにアクセスするにはログインしてください',
	userLoginWelcomeSubtitle: 'SMSを、美しいフォトブックに印刷してお届けします。',
	userLoginWelcomeTitle: 'ようこそ！',
	userLoginNoConnexion: 'ログイン履歴なし',
	userLoginTitle: 'ログイン',
	userLogout: 'ログアウト',
	userName: '名前',
	userNewPassword: '新しいパスワード',
	userNewsletterSubscribeButton: 'ニュースレターに登録',
	userNewsletterText1: '新着情報やお得な情報、キャンペーンをメールで直接お届けします',
	userOldPassword: '現在のパスワード',
	userOptions: 'ユーザー設定',
	userPassword: 'パスワード',
	userPasswordConfirmation: 'パスワードの確認',
	userPasswordConfirmationError: 'パスワードと同じ内容を確認欄にご入力ください。',
	userPasswordConfirmationRestriction: '確認欄は入力したパスワードと同じ内容にしてください',
	userPasswordEdit: 'パスワードを変更',
	userPasswordSet: 'パスワードを設定',
	userPasswordSetSuccess: 'パスワードを保存しました。',
	userSocialConnectionsTitle: 'ログイン方法',
	userSocialContinueApple: 'Appleで続ける',
	userSocialContinueGoogle: 'Googleで続ける',
	userSocialDivider: 'または',
	userSocialError: 'ログインに失敗しました。もう一度お試しください。',
	userSocialErrorNoEmail: 'Appleアカウントからメールアドレスが提供されませんでした。別の方法をご利用ください。',
	userSocialErrorUnavailable: 'このログイン方法はまだ利用できません。',
	userSocialLinkApple: 'Appleを連携',
	userSocialLinkGoogle: 'Googleを連携',
	userSocialLinkSuccess: 'アカウントを連携しました。',
	userSocialLinked: '連携済み',
	userSocialUnlinkApple: 'Appleの連携を解除',
	userSocialUnlinkConfirm: 'このログイン方法の連携を解除しますか？',
	userSocialUnlinkGoogle: 'Googleの連携を解除',
	userSocialUnlinkLastError: '最後のログイン方法を解除する前にパスワードを設定してください。',
	userSocialUnlinkSuccess: '連携を解除しました。',
	userPasswordError: '正しいパスワードをご入力ください。',
	userPasswordResetText: 'ご希望のパスワードをご入力ください。確認欄にも入力し、下のボタンをクリックしてください。',
	userPasswordRestriction: 'パスワードは6文字以上で、数字1文字と記号（@&!()$*€%）1文字を含める必要があります。',
	userPasswordRestrictionAlt: 'パスワードは6文字以上である必要があります。',
	userPasswordTemporaryCheckButton: '仮パスワードを受け取りました',
	userPhone: '電話番号',
	userPhoneError: '電話番号が正しくありません。',
	userProfileMy: 'マイプロフィール',
	userReInitPassword: 'パスワードを再設定',
	userRecoverFromOldAppCheckButton: 'パスワード再設定のメールを受け取りました',
	userRecoverFromOldAppText: 'お客様のアカウントは新しいアプリへ移行されました。メールボックスをご確認いただき、パスワードを取得して新しいアカウントを有効化してください。',
	userRegister: 'アカウントを作成',
	userRegisterError: 'アカウントを作成できませんでした。メールアドレスをご確認のうえ、もう一度お試しください。',
	userRegisterSuccess: 'おめでとうございます。アカウントを作成しました。仮パスワードを記載したメールをお送りします。',
	userRegisterSuccessEmailNotice: '確認メールを{email}宛にお送りしました。',
	userRegisterSuccessEyebrow: 'ようこそ',
	userRegisterSuccessPageTitle: 'ようこそ！',
	userRegisterSuccessSourcesHint: 'メッセージが保存されているアプリを選んでください。',
	userRegisterSuccessSourcesTitle: 'どこから始めますか？',
	userRegisterSuccessStep1Desc: 'ご登録内容のご案内が届いています。',
	userRegisterSuccessStep1Title: 'メールボックスを確認',
	userRegisterSuccessStep2Desc: 'WhatsApp、Messenger、Instagram、iOS、Android：ご利用のアプリを選びましょう。',
	userRegisterSuccessStep2Title: 'メッセージをインポート',
	userRegisterSuccessStep3Desc: '表紙、色、写真：細部まで自由にカスタマイズできます。',
	userRegisterSuccessStep3Title: '本を作成',
	userRegisterSuccessStepsEyebrow: '制作の流れ',
	userRegisterSuccessText: 'アカウントの準備が整いました。数ステップで、メッセージを大切に残せる本に変えましょう。',
	userRegisterSuccessTitle: '物語はここから始まります',
	userRegisterSuccessTitleNamed: '{firstName}さん、ようこそ！',
	userResetPasswordAccountButton: 'アカウントのパスワードを再設定',
	userResetPasswordAskSuccess: 'メールボックスをご確認いただき、パスワード再設定のリンクをクリックしてください。',
	userResetPasswordButton: 'パスワードを再設定',
	userResetPasswordError: 'パスワードを再設定できませんでした。しばらくしてからもう一度お試しください。',
	userResetPasswordInfo: 'パスワードを再設定するための確認リンクをメールでお送りします。',
	userResetPasswordInfo2: '以下の項目を入力して、パスワードを再設定してください：',
	userResetPasswordSuccess: 'パスワードを再設定しました。',
	userRole: '権限',
	userRoleAdmin: '管理者',
	userRoleCustomer: 'お客様',
	userSearchLabel: 'ユーザーのメールアドレスまたは名前を入力してください',
	userSendNewAccountEmail: '新規アカウントのメールをユーザーに送信',
	userSendNewAccountEmailSuccess: 'ユーザーに通知しました。',
	userSwitch: 'ユーザーを変更',
	userValidForgotPasswordError: 'パスワード再設定用のコードを送信できませんでした。',
	userValidForgotPasswordSuccess: 'メールボックスをご確認いただき、確認コードを使ってパスワードを再設定してください。',
	users: 'ユーザー',
	usersList: 'ユーザー一覧',
	valid: '確認',
	vatExempt: '消費税免除',
	vatRates: '国別の付加価値税率',
	vatRatesAddCountry: '国を追加',
	vatRatesAdminHint: '配送先の国ごとに付加価値税率を設定します。お客様のお支払い額は変わりません。',
	vatRatesEmpty: '国が未設定です。すべての注文が付加価値税0%で請求されます。',
	vatReport: '付加価値税レポート',
	vatReportAdminHint: '期間中、国ごとに請求した付加価値税です。申告の準備に使えます。',
	vatReportUnknownCountry: '国不明',
	vatRatesIntro: '適用税率は配送先の国です（デジタル商品のみの場合は請求先の国）。お支払い額は同じで、税抜価格と税額の内訳だけが変わります。',
	vatRatesIntroFallback: 'この表にない国は付加価値税0%で請求されます。紙の本、電子書籍、送料に同じ税率が適用されます。',
	vatRatesInvalid: '{country}の税率を確認してください。0〜100のパーセントを入力してください。',
	vatRatesSaveSuccess: '付加価値税率を保存しました。',
	vatRatesSimulation: '税込価格での試算',
	view: '表示',
	voucher: 'クーポン',
	voucherAdd: 'クーポンを追加',
	voucherAdminListHint: 'クーポンコード、適用条件、利用回数の上限を作成・管理できます。',
	voucherApplyButton: '適用',
	voucherApplyComplete: 'これ以上クーポンを追加することはできません。',
	voucherApplyFormLabel: 'クーポンコード',
	voucherApplyValidError: 'このクーポンはご注文に適用できませんでした。',
	voucherCode: 'コード',
	voucherCodePlaceholder: 'クーポンコードを入力してください',
	voucherDeleteConfirmMessage: 'このクーポンを削除してもよろしいですか？',
	voucherEdit: 'クーポンを編集',
	voucherIsAuto: '自動適用',
	voucherIsCumulative: '併用可',
	voucherIsPublic: '公開',
	voucherNotExistsError: 'このクーポンは存在しません。',
	voucherPriority: '優先度',
	voucherProductOffer: 'おすすめ',
	voucherRemoveAllButton: 'すべてのクーポンを削除',
	vouchers: 'クーポン',
	weight: '重量',
	yes: 'はい',
	you: 'あなた',
	yourself: '自分',
	userNewsletterTitle: 'ニュースレター',
	userNewsletterSubscribeText: '新商品やキャンペーン、おすすめの情報をお届けします',
	userNewsletterUnSubscribeButton: 'ニュースレターの配信を停止',
	userOrdersView: 'ユーザーの注文を表示',
	userCanCustomizeMessages: 'メッセージのカスタマイズ可',
	userLogAsUser: 'このユーザーとしてログイン',
	shippingMethodProviderData: '配送業者の情報',
	productUseForCustomization: 'カスタマイズに使用',
	conversationBookFormat: '本のサイズ',
	conversationMessageSelect: 'このメッセージを選択',
	conversationMessagesLuxEyebrow: '本',
	conversationMessagesLuxHint: 'メッセージを検索、非表示、編集できます。変更内容は選択中のメッセージに適用されます。',
	conversationMessagesLuxSavePreview: '保存してプレビューに戻る',
	conversationMessagesLuxBackPreview: 'プレビューを見る',
	conversationMessagesLuxCount: '選択中のメッセージ{messages, number}件、写真{photos, number}件、メディア{medias, number}件',
	conversationMessagesFilterResults: '{count, number} {count, plural, one {件の結果} other {件の結果}}',
	conversationMessagesOnlyHidden: '非表示のみ',
	conversationMessagesResetFilters: 'フィルターをリセット',
	conversationMessagesShowHidden: '非表示のメッセージを表示',
	conversationMessagesResetChanges: 'すべての変更を取り消す',
	conversationMessagesResetChangesButton: 'すべて取り消す',
	conversationMessagesResetChangesConfirm: '会話はインポートした直後の状態に戻ります。これまでの変更（非表示、編集、追加したメッセージ）はすべて失われ、元に戻せません。続けてもよろしいですか？',
	conversationMediaTypePhotos: '写真',
	conversationMediaTypeVideos: '動画',
	conversationMediaTypeAudios: '音声',
	conversationMediaTypeLinks: 'リンク',
	conversationMediaTypeOther: 'その他',
	conversationMessagesToolSearch: '検索',
	conversationMessagesToolMedias: 'メディア',
	conversationMessagesToolDates: '日付',
	conversationMessagesToolHidePeriod: '期間を非表示',
	conversationMessagesToolHidden: '表示設定',
	conversationMessagesToolReset: '変更',
	conversationMessagesToolResetNone: 'なし',
	conversationMessagesToolResetCount: '{count, number} {count, plural, one {件の変更} other {件の変更}}',
	conversationMessagesHiddenViewHint: '以下のリストに表示するメッセージを選んでください。',
	conversationMessagesHiddenViewAll: 'すべて',
	conversationMessagesHiddenViewVisible: '表示中',
	conversationMessagesHiddenViewHidden: '非表示',
	conversationMessagesResetChangesHint: '会話をインポートした直後の状態に戻します。これまでの変更（非表示、編集、追加したメッセージ）はすべて失われます。',
	conversationMessagesToolSearchNone: 'なし',
	conversationMessagesToolMediasAll: 'すべてのメッセージ',
	conversationMessagesToolDatesAll: '全期間',
	conversationMessagesToolHidePeriodNone: '期間なし',
	conversationMessagesToolHiddenShown: '表示中',
	conversationMessagesToolHiddenMasked: '非表示',
	conversationMessagesBestofCuratedHint: 'ベストオブはすでに組み上がっており、最大ページ数まで埋まっています。メッセージを非表示にすることはできます。再表示は、本が長くならない範囲で可能です。',
	conversationMessagesBestofFullError: 'ベストオブはすでにいっぱいです。これらのメッセージを表示するには、まず他の箇所で約{pages, number}ページを非表示にしてください。',
	conversationMessagesHidePeriodHint: '指定した2つの日付の間にあるメッセージを、まとめて非表示（または再表示）にできます。',
	conversationMessagesHidePeriodFrom: '開始日',
	conversationMessagesHidePeriodTo: '終了日',
	conversationMessagesHidePeriodCount: 'この期間のメッセージ {count, number} {count, plural, one {件} other {件}}（表示中{visible}件、非表示{hidden}件）',
	conversationMessagesHidePeriodConfirmHide: 'この期間のメッセージ {count, number} {count, plural, one {件} other {件}}を非表示にしてもよろしいですか？',
	conversationMessagesHidePeriodConfirmShow: 'この期間のメッセージ {count, number} {count, plural, one {件} other {件}}を再表示してもよろしいですか？',
	conversationMessagesHidePeriodHide: 'この期間を非表示にする',
	conversationMessagesHidePeriodShow: 'この期間を再表示する',
	conversationMessagesHidePeriodItem: '期間{index}',
	conversationMessagesHidePeriodAdd: '期間を追加',
	conversationMessagesHidePeriodInvalid: '終了日は開始日より後の日付にしてください。',
	conversationMessagesToolHidePeriodCount: '{count, number} {count, plural, one {件の期間} other {件の期間}}',
	conversationMessagesSearchPlaceholder: '単語や名前で検索…',
	conversationMessagesEditTitle: 'メッセージのカスタマイズ',
	conversationMessageSelectorDateFrom: 'この日付以降のメッセージを選択',
	conversationMessageSelectorDateTo: 'この日付以前のメッセージを選択',
	conversationTextSearch: 'メッセージ本文を検索',
	conversationOnlyMedias: 'メディアのみ表示',
	conversationMessagesSelectVisible: 'このページを選択',
	conversationMessagesSelectAllFiltered: 'すべて選択（{count, number}件）',
	unselect: '選択解除',
	conversationMessagesEditHideSelected: '選択したメッセージを非表示',
	conversationMessagesEditShowSelected: '選択したメッセージを表示',
	conversationMessagesEditTooManySelected: '選択したメッセージが多すぎます',
	conversationNoMessages: 'メッセージがありません',
	conversationMessageEdit: 'メッセージを編集',
	conversationMessageAdd: 'メッセージを追加',
	conversationMessageInsert: 'ここにメッセージを挿入',
	conversationMessageEditSelect: 'このメッセージを選択',
	conversationMessageEditUnselect: 'このメッセージの選択を解除',
	conversationMessageHiddenAlert: 'このメッセージは非表示に設定されているため、印刷される本には掲載されません。',
	conversationMessageSetUnVisibleButton: 'このメッセージを本に印刷しない',
	conversationMessageSetVisibleButton: 'メッセージを再表示',
	conversationMessagesEditEnableButton: 'カスタマイズを有効にする',
	conversationMessagesEditEnableButton2: '{price}でカスタマイズを有効にする',
	conversationMessagesEditDisableAlert: 'メッセージのカスタマイズ機能は、お支払いいただくと有効になります。',
	conversationMessageDateHint: '日時を変更すると、このメッセージを会話内の好きな位置に置けます。',
	conversationMessageSender: '送信者',
	conversationMessageSenderPlaceholder: '送信者を選ぶ',
	conversationMessageSenderRequiredHint: '保存するには、このメッセージの送信者を選んでください。',
	conversationMessageAnnotation: '注釈',
	conversationMessageAnnotationNoMedia: '注釈には写真、動画、音声を添付できません。',
	conversationMessageText: 'テキスト',
	conversationMessageTextPlaceholder: 'テキストを入力',
	conversationMessageAttachments: '添付ファイル',
	conversationMessageMediaLabel: '写真、動画または音声',
	conversationMessageMediaDragDrop: '写真、動画または音声ファイルをここにドラッグ',
	conversationMessageMediaTapSelect: 'タップして写真、動画または音声を選ぶ',
	conversationMessageMediaOpenFinder: 'ファイルを選ぶ',
	conversationMessageMediaPickSenderFirst: '写真、動画または音声を追加するには、先に送信者を選んでください。',
	conversationMessageHiddenLabel: 'メッセージを非表示にする',
	conversationGenerate: '本を生成',
	conversationVerify: '強制的に検証',
	conversationLaunchButton: '本番環境で実行',
	conversationViewButton: '会話を見る',
	reset: 'リセット',
	cmsLinkColor: 'ボタンの色',
	cmsLinkNeedObfuscate: '難読化する',
	cmsImageUseForMobile: 'モバイル表示に使用する',
	contentEditPage: 'ページを編集',
	cmsRedirectionAdd: 'リダイレクトを追加',
	cmsContentEdit: 'コンテンツを編集',
	cmsPageIsActive: '有効にする',
	cmsContentTypeLabel: 'コンテンツタイプ',
	cmsContentModelLabel: 'コンテンツテンプレート',
	cmsContentTitle: 'タイトル',
	cmsContentSlug: 'スラッグ',
	cmsPanelIsTemplate: 'テンプレートに含める',
	cmsPageSeoTitle: 'SEOタイトル',
	cmsPageSeoDescription: 'SEOディスクリプション',
	cmsPageSeoKeywords: 'SEOキーワード',
	cmsPageSeoHideOnSitemap: 'サイトマップに表示しない',
	cmsPageSeoUseCustomTitleSuffix: 'カスタムのタイトル接尾辞を使用する',
	cmsPageSeoTitleSuffix: 'タイトル接尾辞',
	affiliation: 'アフィリエイト',
	affiliationInvoiceTotalAdminTitle: 'お支払い合計（消費税込）',
	conversationImportLuxEyebrow: '物語',
	conversationImportLuxTagline: '世界にひとつだけの贈り物。この人にしか贈れない一冊です。',
	conversationImportLuxPrivacy: 'メッセージの内容が外部に公開されることはありません：お選びいただいた会話だけを使用します。',
	conversationImportProgressExport: 'エクスポート',
	conversationImportProgressUpload: 'アップロード',
	conversationImportProgressCustomize: 'カスタマイズ',
	conversationImportUploadSuccess: 'アーカイブを受け取りました：次のステップで会話を選んでください',
	conversationImportUploadSuccessSingle: 'ファイルを受け取りました：このまま本のカスタマイズに進んでください',
	conversationImportContinueSingle: '続ける',
	conversationImportSelectionTitleSingle: '会話',
	conversationImportSelectionHintSingle: 'ファイルの中に会話が1件見つかりました。',
	conversationImportSelectionHintMultiple: '本にしたい会話を選んでください：検索を使うとリストを絞り込めます。',
	conversationImportSelectionListCount: '{total}件中{shown}件の会話',
	conversationImportSelectionNoMatch: '検索条件に一致する会話がありません。',
	conversationImportStepPickThread: '会話を選ぶ',
	conversationImportStepMedia: '写真のオプション',
	conversationImportStepTerms: '利用規約に同意',
	conversationImportExtrasLockedHint: '上で会話を選ぶと、これらのオプションが利用できます。',
	conversationImportPickThreadBeforeTerms: '続けるには、上で会話を選んでください。',
	conversationImportChangeThread: '会話を変更',
	conversationImportSelectionConfirmedHint: 'これで準備完了です：下で本をカスタマイズできます。',
	conversationImportOptionsTitle: '写真と思い出',
	conversationImportOptionsHint: '初期設定ではすべて選択されています：含めたくないものだけチェックを外してください。',
	conversationImportOptionsImagesLabel: '写真と画像',
	conversationImportOptionsImagesDesc: '会話に含まれる写真が本に印刷されます。',
	conversationImportOptionsMediasLabel: '動画、音声、GIF',
	conversationImportOptionsMediasDesc: '本に印刷されるQRコードからご覧いただけます（10年間の保管が無料）。',
	conversationImportOptionsTransferNote: '写真の枚数によって転送に数分かかることがあります。このページを開いたままにしてください。',
	conversationImportOptionsNoMedia: 'ファイルに写真やメディアが含まれていません：本にはメッセージのみが収録されます。',
	conversationImportAgreementRead: '販売に関する利用規約を確認する',
	conversationImportCreateBook: '本を作る',
	conversationImportSelectToContinue: '続けるには会話を選択してください。',
	conversationImportAcceptTermsToContinue: '続けるには利用規約のチェックボックスにチェックを入れてください。',
	conversationImportDropHint: 'ここに .zip ファイルをドロップ、または',
	conversationImportDropFormats: '完全な .zip を推奨します：開かずにそのままアップロードしてください（写真とメディアを含みます）',
	conversationImportJsonOnlyHint: '.json ファイルのみの場合：写真やメディアは含まれません。写真入りの本にするには、完全な .zip を開かずにアップロードしてください。ブラウザがすでにアーカイブを展開している場合は、「messages」フォルダを .zip に圧縮してください。',
	conversationInstagramImportIntro: 'Instagramのメッセージを取り出す3つのステップ：',
	conversationInstagramImportDemoTitle: 'Instagramのメッセージを書き出す',
	conversationInstagramImportDemoExportMeta: '端末へエクスポート · JSON',
	conversationInstagramImportDemoDownloadsAvailable: '利用可能なダウンロード',
	conversationInstagramImportDemoStartExport: 'エクスポートを開始',
	conversationInstagramImportDemoCustomizeMessages: 'メッセージのみ',
	conversationInstagramImportDemoCustomize: '情報をカスタマイズ',
	conversationInstagramImportDemoConfirmTitle: 'エクスポートを確認',
	conversationInstagramImportDemoSave: '保存',
	conversationInstagramImportDemoMessagesTip: '任意ですが早い：すべてクリア後、メッセージのみ。',
	conversationInstagramImportDemoDataPayments: '支払い',
	conversationInstagramImportDemoDataComments: 'コメント',
	conversationInstagramImportDemoClearAll: 'すべてクリア',
	conversationInstagramImportDemoActivitySection: 'Instagramのアクティビティ',
	conversationInstagramImportDemoPickSpecific: 'エクスポートする情報を選択',
	conversationInstagramImportDemoExportExternal: '外部サービスにエクスポート',
	conversationInstagramImportDemoExportDevice: '端末にエクスポート',
	conversationInstagramImportDemoChooseDestination: 'エクスポート先を選択',
	conversationInstagramImportDemoProfileAccount: 'あなたのアカウント · Instagram',
	conversationInstagramImportDemoProfileName: 'あなたのアカウント名',
	conversationInstagramImportDemoAccountShort: 'あなたのアカウント',
	conversationInstagramImportDemoProfiles: 'プロフィール',
	conversationInstagramImportDemoChooseProfile: 'プロフィールを選択',
	conversationInstagramImportDemoPastActivity: '過去のアクティビティ',
	conversationInstagramImportDemoCurrentActivity: '進行中のアクティビティ',
	conversationInstagramImportDemoCreateExport: 'エクスポートを作成',
	conversationInstagramImportDemoExportIntro: '端末にダウンロードする情報のコピーを作成します。',
	conversationInstagramImportDemoExportTitle: '情報をエクスポート',
	conversationInstagramImportDemoCaptionStart: 'エクスポートを開始をタップ',
	conversationInstagramImportDemoCaptionDevice: '端末にエクスポートをタップ',
	conversationInstagramImportDemoCaptionProfile: 'Instagramプロフィールを選択',
	conversationInstagramImportDemoCaptionCreate: 'エクスポートを作成をタップ',
	conversationInstagramImportDemoCaptionMessages: 'コツ：すべてクリア後、メッセージのみ（より早い）',
	conversationInstagramImportDemoCaptionJson: 'JSON形式を選び、保存',
	conversationInstagramImportDemoCaptionDrop: '準備できたら.zipをダウンロードし、下へアップロード',
	conversationInstagramImportDemoPlatform: 'Instagram',
	conversationInstagramImportDemoDataMessages: 'メッセージ',
	conversationInstagramImportDemoFormat: '形式',
	conversationInstagramImportDemoMediaQuality: 'メディア品質',
	conversationInstagramImportDemoQualityLow: '低',
	conversationInstagramImportDemoJsonNotice: '本にはJSONが必要です。HTMLは使えません。',
	conversationInstagramImportDemoReadyHint: '開かずに完全な.zipを下へアップロード。会話はその後に選びます。',
	conversationInstagramImportCta: 'Instagram の設定を開く',
	conversationInstagramImportStep1: '<b>エクスポートを作成</b>をタップし、<b>Instagram</b>プロフィールを選び、<b>端末にエクスポート</b>を選びます。',
	conversationInstagramImportStep2: '早くするコツ：<b>すべてクリア</b>して<b>メッセージ</b>だけにチェック。<b>JSON</b>形式と<b>低</b>画質を選びます。',
	conversationInstagramImportStep3: '<b>エクスポートを開始</b>をタップし、メールを待ち（10分〜24時間）、<b>.zip</b>を<b>開かずに</b>下へアップロード。会話は<b>その後</b>に選びます。',
	conversationInstagramImportAlert: '<b>JSON</b>形式が必須です（HTML不可）。コツ：<b>メッセージ</b>だけにすると早いですが、必須ではありません。',
	conversationInstagramImportDetailTitle: 'Instagram のエクスポート：詳しい手順',
	conversationInstagramImportDetailIntro: '下のスクリーンショットに従ってください。上のボタンでエクスポートページを直接開けます。',
	conversationInstagramImportDetailSkipApp: 'ボタンでページを開きました：ステップ5から始める',
	conversationInstagramImportDetailStep1: '<b>Instagram</b> アプリを開き、右上の三点メニューから <b>設定</b> に進んでください。',
	conversationInstagramImportDetailStep2: '<b>アカウントセンター</b> を選んでください。',
	conversationInstagramImportDetailStep3: '<b>あなたの情報とアクセス許可</b> をタップしてください。',
	conversationInstagramImportDetailStep4: '<b>あなたの情報をエクスポート</b> を選んでください。',
	conversationInstagramImportDetailStep5: '<b>情報をダウンロードまたは転送</b> に進んでください。上のボタンを使った場合は、すでにこのページが表示されています。',
	conversationInstagramImportDetailStep6: '<b>Instagram</b> を選んでください。アカウントによっては、このステップが表示されないことがあります。',
	conversationInstagramImportDetailStep7: '<b>一部の情報</b> を選んでください。',
	conversationInstagramImportDetailStep8: '<b>メッセージ</b> までスクロールしてチェックを入れ、<b>次へ</b> をタップしてください。',
	conversationInstagramImportDetailStep9: '<b>デバイスにダウンロード</b> をタップしてください。',
	conversationInstagramImportDetailStep10: 'ご希望の期間と <b>JSON</b> 形式を選んでください。メディアの画質を <b>低</b> にすると、ダウンロードが速くなります。',
	conversationInstagramImportDetailStep11: 'アーカイブは <b>10分から24時間</b> で準備が整います。用意ができるとメールでお知らせします：アカウントセンターのページからも確認できます。',
	conversationInstagramImportDetailStep12: '完全な <b>.zip</b> ファイルをデバイスにダウンロードし、<b>開かずに</b>下にアップロードしてください。本に使われるのは、このあとお選びいただく会話だけです。',
	conversationKakaotalkImportIntro: 'まずはスマートフォンから。iPhoneとAndroid、どちらをご利用ですか？',
	conversationKakaotalkImportPlatformIphone: 'iPhone',
	conversationKakaotalkImportPlatformAndroid: 'Android',
	conversationKakaotalkImportIphoneStep1: 'iPhone で <b>KakaoTalk</b> を開き、本にしたい会話を表示してください。',
	conversationKakaotalkImportIphoneStep2: '右上の <b>メニュー</b>（☰）をタップし、パネル下部の <b>設定</b> アイコンをタップしてください。',
	conversationKakaotalkImportIphoneStep3: '<b>会話をエクスポート</b> をタップし、<b>テキストメッセージのみ送信</b> を選んでください。',
	conversationKakaotalkImportIphoneStep4: '<b>.txt</b> ファイルを保存し（ファイル、メール、AirDrop）、<b>編集せずに</b>下にアップロードしてください。',
	conversationKakaotalkImportAndroidStep1: 'スマートフォンで <b>KakaoTalk</b> を開き、本にしたい会話を表示してください。',
	conversationKakaotalkImportAndroidStep2: '右上の <b>メニュー</b>（☰）をタップし、パネル下部の <b>設定</b> アイコンをタップしてください。',
	conversationKakaotalkImportAndroidStep3: '<b>会話をエクスポート</b> をタップし、<b>テキストのみ送信</b> を選んでください。',
	conversationKakaotalkImportAndroidStep4: '<b>.txt</b> ファイルを保存し（ファイル、Google Drive、メール）、<b>編集せずに</b>下にアップロードしてください。',
	conversationKakaotalkImportAlert: '1回のエクスポートにつき会話は1件です。もう一方のオプションでは写真も保存されますが、KakaoTalk は写真をメッセージに紐づけません：テキストのみを選んでください。写真は「写真」という文字だけで表示されます。',
	conversationKakaotalkImportDesktopNote: 'パソコン（Windows または Mac）の場合：会話のメニューを開き、<b>会話を保存</b> を選んでください。保存された <b>.txt</b> ファイルもここでお使いいただけます。',
	conversationLineImportIntro: 'まずはスマートフォンから。iPhoneとAndroid、どちらをご利用ですか？',
	conversationLineImportPlatformIphone: 'iPhone',
	conversationLineImportPlatformAndroid: 'Android',
	conversationLineImportIphoneStep1: 'iPhone で <b>LINE</b> を開き、本にしたい会話（トーク）を表示してください。',
	conversationLineImportIphoneStep2: 'トーク画面の上部にある <b>メニュー</b>（☰）→ <b>設定</b> をタップしてください。',
	conversationLineImportIphoneStep3: '<b>トーク履歴を送信</b> をタップし、ファイルの送信方法（ファイル、メール、AirDrop）を選んでください。',
	conversationLineImportIphoneStep4: '<b>.txt</b> ファイルを保存し、<b>編集せずに</b>下にアップロードしてください。',
	conversationLineImportAndroidStep1: 'スマートフォンで <b>LINE</b> を開き、本にしたい会話（トーク）を表示してください。',
	conversationLineImportAndroidStep2: 'トーク画面の上部にある <b>メニュー</b>（☰）→ <b>設定</b> をタップしてください。',
	conversationLineImportAndroidStep3: '<b>トーク履歴を送信</b> をタップし、ファイルの送信方法（ファイル、Google Drive、メール）を選んでください。',
	conversationLineImportAndroidStep4: '<b>.txt</b> ファイルを保存し、<b>編集せずに</b>下にアップロードしてください。',
	conversationLineImportAlert: '1回のエクスポートにつき会話は1件です。保存されるのはトークルームに現在表示されているメッセージのみで、LINE は写真もスタンプも画像としてはエクスポートしません。',
	conversationLineImportDesktopNote: 'パソコン（Windows または Mac）の場合：<b>トーク</b> を開いて会話をダブルクリックし、上部の <b>メニュー</b> → <b>トーク履歴を保存</b> を選んでください。このエクスポートは Chrome 版 LINE にはありません。',
	conversationLinkedinImportIntro: 'LinkedIn の会話を取り出す3つのステップ：',
	conversationLinkedinImportCta: 'LinkedIn のエクスポートページを開く',
	conversationLinkedinImportStep1: '<b>ウェブブラウザ</b>（パソコンまたはスマートフォン）で上のページを開いてください。開けない場合は <b>自分</b> → <b>設定とプライバシー</b> → <b>データプライバシー</b> → <b>データのコピーを取得</b> と進みます。',
	conversationLinkedinImportStep2: '<b>メッセージ</b> を含むアーカイブをリクエストします：<b>メッセージ</b> のファイルにチェックを入れるか、アーカイブ全体を選び、<b>アーカイブをリクエスト</b> をクリックしてください。',
	conversationLinkedinImportStep3: 'LinkedIn からのメール（10分から24時間で届きます）で <b>.zip</b> をダウンロードし、<b>開かずに</b>下にアップロードしてください：会話はアップロードの<b>あと</b>でお選びいただけます。',
	conversationLinkedinImportAlert: 'このエクスポートは LinkedIn のモバイルアプリにはありません：ブラウザからご利用ください。アーカイブには <b>messages.csv</b> ファイルが含まれている必要があります（LinkedIn は写真も添付ファイルもエクスポートしません）。',
	conversationSnapchatImportIntro: 'Snapchat の会話を取り出す3つのステップ：',
	conversationSnapchatImportCta: 'Snapchat の「マイデータ」を開く',
	conversationSnapchatImportStep1: 'アプリでアバター → 設定（歯車アイコン）→ <b>プライバシー</b> → <b>マイデータ</b> と進んでください。上のリンクからも開けます。',
	conversationSnapchatImportStep2: '必要に応じてログインし、ページ下部の <b>リクエストを送信</b> をタップしてください：アーカイブの準備ができると Snapchat からメールが届きます（数時間から1日程度）。',
	conversationSnapchatImportStep3: 'メールから <b>.zip</b> をダウンロードし、<b>開かずに</b>下にアップロードしてください：会話はアップロードの<b>あと</b>でお選びいただけます。',
	conversationSnapchatImportAlert: '完全な <b>.zip</b> アーカイブが必要です：開かないでください。メッセージは本に印刷されます（Snapchat のエクスポートには印刷できる写真は含まれていません）。',
	conversationSnapchatPlaceholderMedia: '[メディア]',
	conversationSnapchatPlaceholderNote: '[ボイスノート]',
	conversationSnapchatPlaceholderSticker: '[スタンプ]',
	conversationSnapchatPlaceholderSnap: '[Snap]',
	conversationSnapchatPlaceholderAudio: '[音声]',
	conversationSnapchatStatusParticipantAdded: 'メンバーがグループに追加されました',
	conversationSnapchatStatusNameChanged: 'グループ名が変更されました',
	conversationSnapchatStatusConversationCreated: '会話が作成されました',
	conversationSnapchatStatusGeneric: 'Snapchatの通知',
	conversationSnapchatImportPartialContent: '{total}件中{withText}件にテキストがあります。Snapchatは未保存メッセージの本文を書き出しません。',
	conversationSnapchatImportDetailTitle: 'Snapchat のエクスポート：詳しい手順',
	conversationSnapchatImportDetailIntro: '下のスクリーンショットを見ながら各ステップを進めてください。上のボタンから「マイデータ」を直接開いて、ステップ4に進むこともできます。',
	conversationSnapchatImportDetailSkipApp: 'ボタンでページを開きました：ステップ4から始める',
	conversationSnapchatImportDetailStep1: '<b>Snapchat</b> を開き、プロフィール写真をタップしてください。',
	conversationSnapchatImportDetailStep2: '<b>歯車</b> アイコンをタップして設定を開いてください。',
	conversationSnapchatImportDetailStep3: '<b>アカウントの操作</b> までスクロールし、<b>マイデータ</b> をタップしてください。上のボタンからも開けます。',
	conversationSnapchatImportDetailStep4: '<b>チャット履歴</b> にチェックを入れ、<b>JSON</b> と <b>HTML</b> の形式を選んで、<b>次へ</b> をタップしてください。',
	conversationSnapchatImportDetailStep5: 'ご希望の期間を選び、メールアドレスを確認して、<b>送信</b> をタップしてください。',
	conversationSnapchatImportDetailStep6: 'エクスポートが終わると Snapchat からメールが届きます：数時間から数日かかることがあります。',
	conversationSnapchatImportDetailStep7: 'メールが届いたら、リンクをクリックしてデータにアクセスしてください。',
	conversationSnapchatImportDetailStep8: 'Snapchat で <b>エクスポートを表示</b> をタップし、<b>ダウンロード</b> をタップしてください。',
	conversationSnapchatImportDetailStep9: '完全な <b>.zip</b> ファイルをデバイスにダウンロードし、<b>開かずに</b>下にアップロードしてください。本に使われるのは、このあとお選びいただく会話だけです。',
	conversationTelegramImportIntro: 'Telegram の会話をエクスポートする4つのステップ：',
	conversationTelegramImportCta: 'Telegram Desktop をダウンロード',
	conversationTelegramImportStep1: 'PCでは <b>Telegram Desktop</b> をインストールしてください。MacではApp Storeの「Telegram」は使わず、上のリンクから <b>Telegram Desktop</b> を入手してください（App Storeでは Telegram Lite という名前です）。そのあと、本にしたい会話を開いてください。',
	conversationTelegramImportStep2: '右上の <b>三点メニュー</b> → <b>チャット履歴をエクスポート</b> をクリックしてください。',
	conversationTelegramImportStep3: '<b>写真、動画、ファイル</b> にチェックを入れ、形式は <b>JSON</b> を選んでください（HTMLでも取り込めます）。<b>エクスポート</b> をクリックし、ダウンロードが終わるまでお待ちください。',
	conversationTelegramImportStep4: 'エクスポートされたフォルダを <b>.zip</b> に圧縮し（右クリック → 圧縮）、<b>開かずに</b>下にアップロードしてください：オプションはアップロードの<b>あと</b>で設定できます。',
	conversationTelegramImportAlert: '1回のエクスポートにつき会話は1件です。写真入りの本にするには、エクスポート時に<b>メディア</b>を含めてください：<b>.zip</b>ファイル全体を、そのままアップロードします。',
	conversationTelegramImportDetailTitle: 'Telegramのエクスポート：詳しい手順',
	conversationTelegramImportDetailIntro: '以下のスクリーンショットを見ながら各ステップを進めてください。上のボタンからTelegram Desktopをダウンロードできます。すでにインストール済みの場合はステップ2へお進みください。',
	conversationTelegramImportDetailSkipApp: 'Telegram Desktopはすでにあります：ステップ2から始める',
	conversationTelegramImportDetailStep1: 'PCでは <b>Telegram Desktop</b> が正しいアプリです。Macでは上のリンクから <b>Telegram Desktop</b> を入手してください。App Storeの「Telegram」では書き出せません。App Storeでは正しいソフトの名前は <b>Telegram Lite</b> です。',
	conversationTelegramImportDetailStep2: '本にしたい<b>会話</b>を開いてください。',
	conversationTelegramImportDetailStep3: '右上の<b>三点メニュー</b>をクリックし、<b>チャット履歴をエクスポート</b>を選んでください。',
	conversationTelegramImportDetailStep4: '<b>すべてのファイル形式</b>（写真、動画、ボイスメッセージなど）にチェックを入れ、最大サイズを<b>1500 MB</b>まで上げて、形式は <b>JSON</b> を選んでください。形式の選択が出ない場合は、HTMLの書き出しでも取り込めます。',
	conversationTelegramImportDetailStep5: '右下の<b>エクスポート</b>をクリックして、エクスポートを開始してください。',
	conversationTelegramImportDetailStep6: 'スマートフォンで確認を求められたら<b>許可</b>をタップしてください。エクスポートされたフォルダを<b>.zip</b>に圧縮し、<b>開かずに</b>そのまま下にアップロードしてください：オプションはアップロードのあとで設定できます。',
	conversationImportDetectedPlatform: '{platform}向けの手順です。ほかの選択肢もそのまま選べます。',
	conversationWhatsappImportIntro: 'まずはスマートフォンから。iPhoneとAndroid、どちらをご利用ですか？',
	conversationWhatsappImportPlatformIphone: 'iPhone',
	conversationWhatsappImportPlatformAndroid: 'Android',
	conversationWhatsappImportIphoneStep1: 'トークを開き、上部の<b>名前</b>をタップし、<b>チャットを送信</b>を選びます。',
	conversationWhatsappImportIphoneStep2: '本に写真を入れるなら<b>メディアを含める</b>（テキストのみならメディアなし）。',
	conversationWhatsappImportIphoneStep3: '<b>ファイル</b>に保存し、<b>.zip</b>を<b>開かずに</b>下へアップロードします。',
	conversationWhatsappImportIphoneStep4: '写真入りの本にするなら<b>メディアを添付</b>、メッセージだけなら<b>メディアなし</b>を選んでください：ファイルをパソコンまたはスマートフォンに保存し、<b>開かずに</b>下にアップロードしてください。',
	conversationWhatsappImportAndroidStep1: 'チャットを開き、<b>⋮</b> → <b>その他</b> → <b>チャットをエクスポート</b>の順にタップ。',
	conversationWhatsappImportAndroidStep2: '本に写真を入れるなら <b>メディアを含める</b>（テキストのみなら <b>メディアなし</b>）。',
	conversationWhatsappImportAndroidStep3: 'ファイルを保存または共有し、<b>開かずに</b>下へ <b>.zip</b> をアップロード。',
	conversationWhatsappImportAndroidStep4: 'ファイルを保存し（ファイル、Google Drive、メールなど）、パソコンまたはスマートフォンに転送してから、<b>開かずに</b>下にアップロードしてください。',
	conversationWhatsappImportAlert: '1回の書き出しで1つの会話。イラスト本には<b>メディアを含める</b>を推奨。転送が終わるまでこのページにいてください。',
	conversationWhatsappImportAlertAndroid: '1回の書き出しで1会話。<b>メディアを含める</b>を推奨。一部端末ではメールのみ：その場合は <b>メディアなし</b>。転送が終わるまでこのページにいてください。',
	conversationWhatsappImportIphoneDetailTitle: 'iPhoneでのWhatsAppエクスポート：詳しい手順',
	conversationWhatsappImportIphoneDetailIntro: '以下のスクリーンショットを見ながらiPhoneで各ステップを進め、ファイルをパソコンまたはスマートフォンに転送してからここにアップロードしてください。',
	conversationWhatsappImportIphoneDetailStep1: '<b>WhatsApp</b>を開き、本にしたい会話を表示してください。',
	conversationWhatsappImportIphoneDetailStep2: '画面上部の<b>連絡先名またはグループ名</b>をタップしてください。',
	conversationWhatsappImportIphoneDetailStep3: 'ページの一番下までスクロールして、<b>チャットをエクスポート</b>を探してください。',
	conversationWhatsappImportIphoneDetailStep4: '<b>チャットをエクスポート</b>をタップしてください。',
	conversationWhatsappImportIphoneDetailStep5: '写真入りの本にするなら<b>メディアを添付</b>、メッセージだけなら<b>メディアなし</b>を選んでください。',
	conversationWhatsappImportIphoneDetailStep6: 'ファイルをパソコンまたはスマートフォンに保存し（例：ファイルアプリ）、<b>開かずに</b>下にアップロードしてください。',
	conversationWhatsappImportAndroidDetailTitle: 'AndroidでのWhatsAppエクスポート：詳しい手順',
	conversationWhatsappImportAndroidDetailIntro: '以下のスクリーンショットを見ながらAndroidで各ステップを進め、ファイルをパソコンまたはスマートフォンに転送してからここにアップロードしてください。',
	conversationWhatsappImportAndroidDetailStep1: '<b>WhatsApp</b>を開き、本にしたい会話を表示してください。',
	conversationWhatsappImportAndroidDetailStep2: '<b>⋮</b>（右上）→ <b>その他</b> → <b>チャットをエクスポート</b>の順にタップしてください。',
	conversationWhatsappImportAndroidDetailStep3: '写真も入れる場合は<b>メディアを含める</b>、メッセージだけの場合は<b>メディアなし</b>を選んでください。',
	conversationWhatsappImportAndroidDetailStep4: 'ファイルを保存し（ファイル、Google Drive、メールなど）、パソコンまたはスマートフォンに転送してから、<b>開かずに</b>下にアップロードしてください。',
	conversationWhatsappImportDemoTitle: 'WhatsAppの会話を書き出す',
	conversationWhatsappImportDemoIndividual: '個別チャット',
	conversationWhatsappImportDemoGroup: 'グループチャット',
	conversationWhatsappImportDemoCaptionOpen: 'WhatsAppでトークを開く',
	conversationWhatsappImportDemoCaptionTapName: '上部の名前をタップ',
	conversationWhatsappImportDemoCaptionExport: '下にスクロールしてチャットを送信',
	conversationWhatsappImportDemoCaptionMedia: '本の写真用にメディアを含めるを選ぶ',
	conversationWhatsappImportDemoCaptionSave: 'ファイルに保存して下にアップロード',
	conversationWhatsappImportDemoExportLabel: 'チャットを送信',
	conversationWhatsappImportDemoMediaNotice: 'Attach Media creates a larger archive, ideal for an illustrated book.',
	conversationWhatsappImportDemoAttachMedia: 'メディアを含める',
	conversationWhatsappImportDemoWithoutMedia: 'メディアなし',
	conversationWhatsappImportDemoSaveFiles: 'ファイルに保存',
	conversationWhatsappImportDemoA11y: 'アニメ案内：トークを開き、名前をタップ、書き出し、メディアを含める、ファイルに保存。',
	conversationWhatsappImportDemoCaptionExportGroup: '⋯メニューを開きチャットを送信',
	conversationWhatsappImportDemoContactName: 'Léa',
	conversationWhatsappImportDemoContactMom: '母',
	conversationWhatsappImportDemoGroupName: '週末グループ',
	conversationWhatsappImportDemoGroupWork: 'Work : design',
	conversationWhatsappImportDemoChats: 'チャット',
	conversationWhatsappImportDemoHeaderSubContact: 'tap here for contact info',
	conversationWhatsappImportDemoHeaderSubGroup: 'tap here for group info',
	conversationWhatsappImportDemoGroupsInCommon: 'Groups in common',
	conversationWhatsappImportDemoSeeAll: 'See all ›',
	conversationWhatsappImportDemoAddFavorite: 'Add to Favorites',
	conversationWhatsappImportDemoAddList: 'Add to a list',
	conversationWhatsappImportDemoClearChat: 'チャットを消去',
	conversationWhatsappImportDemoBlock: 'Block',
	conversationWhatsappImportDemoParticipants: '{count} participants',
	conversationWhatsappImportDemoAudio: 'Audio',
	conversationWhatsappImportDemoVideo: 'Video',
	conversationWhatsappImportDemoAdd: 'Add',
	conversationWhatsappImportDemoSearch: 'Search',
	conversationWhatsappImportDemoMemberYou: 'You',
	conversationWhatsappImportDemoMemberAlex: 'Alex',
	conversationWhatsappImportDemoMemberCamille: 'Camille',
	conversationWhatsappImportDemoEditGroup: 'Edit group info',
	conversationWhatsappImportDemoEditDescription: 'Edit description',
	conversationWhatsappImportAndroidDemoIncludeMedia: 'メディアを含める',
	conversationWhatsappImportAndroidDemoWithoutMedia: 'メディアなし',
	conversationWhatsappImportAndroidDemoMediaNotice: 'イラスト本にはメディアを含める。メディアなしは軽量。',
	conversationWhatsappImportAndroidDemoClear: 'チャットを消去',
	conversationWhatsappImportAndroidDemoExport: 'チャットをエクスポート',
	conversationWhatsappImportAndroidDemoReport: '報告',
	conversationWhatsappImportAndroidDemoMore: 'その他',
	conversationWhatsappImportAndroidDemoWallpaper: '壁紙',
	conversationWhatsappImportAndroidDemoMute: '通知をミュート',
	conversationWhatsappImportAndroidDemoOnline: 'オンライン',
	conversationWhatsappImportAndroidDemoCaptionSave: '保存または共有し、下にアップロード',
	conversationWhatsappImportAndroidDemoCaptionMedia: '本の写真用にメディアを含めるを選ぶ',
	conversationWhatsappImportAndroidDemoCaptionExport: 'その他、次いでチャットをエクスポート',
	conversationWhatsappImportAndroidDemoCaptionMenu: '右上のメニューをタップ',
	conversationWhatsappImportAndroidDemoCaptionOpen: 'WhatsAppでトークを開く',
	conversationWhatsappImportAndroidDemoTitle: 'AndroidでWhatsAppの会話を書き出す',
	conversationWhatsappImportAndroidDemoShareHint: 'その後 .zip を開かずに下へアップロード。',
	conversationWhatsappImportAndroidDemoFiles: 'ファイル',
	conversationWhatsappImportAndroidDemoShareVia: '送信先…',
	conversationMessengerImportIntro: 'まず<b>2023年以降</b>から始めてください。暗号化されたチャットは Messenger.com にあります。見つからないときは<b>2023年以前</b>に切り替えてください。',
	conversationMessengerImportContext: '2023年より前に始まった会話は、暗号化をオンにしたあとも続くことがあります。その場合、Messengerはアーカイブを2つに分けます。両方を取り込み、会話リストから1つにまとめてください。',
	conversationMessengerImportPlatformClassic: '2023年以前',
	conversationMessengerImportPlatformEncrypted: '2023年以降',
	conversationMessengerImportClassicCta: 'Metaを開いてエクスポート',
	conversationMessengerClassicImportDemoReadyHint: '開かずに完全な.zipを下へアップロード。会話はその後に選びます。',
	conversationMessengerClassicImportDemoExportMeta: '端末へエクスポート · JSON',
	conversationMessengerClassicImportDemoDownloadsAvailable: '利用可能なダウンロード',
	conversationMessengerClassicImportDemoStartExport: 'エクスポートを開始',
	conversationMessengerClassicImportDemoQualityLow: '低',
	conversationMessengerClassicImportDemoMediaQuality: 'メディア品質',
	conversationMessengerClassicImportDemoCustomizeMessages: 'メッセージのみ',
	conversationMessengerClassicImportDemoCustomize: '情報をカスタマイズ',
	conversationMessengerClassicImportDemoConfirmTitle: 'エクスポートを確認',
	conversationMessengerClassicImportDemoJsonNotice: '本にはJSONが必要です。HTMLは使えません。',
	conversationMessengerClassicImportDemoFormat: '形式',
	conversationMessengerClassicImportDemoSave: '保存',
	conversationMessengerClassicImportDemoMessagesTip: '任意ですが早い：すべてクリア後、メッセージのみ。',
	conversationMessengerClassicImportDemoDataMessages: 'メッセージ',
	conversationMessengerClassicImportDemoDataPayments: '支払い',
	conversationMessengerClassicImportDemoDataComments: 'コメント',
	conversationMessengerClassicImportDemoClearAll: 'すべてクリア',
	conversationMessengerClassicImportDemoPickSpecific: 'エクスポートする情報を選択',
	conversationMessengerClassicImportDemoExportExternal: '外部サービスにエクスポート',
	conversationMessengerClassicImportDemoExportDevice: '端末にエクスポート',
	conversationMessengerClassicImportDemoChooseDestination: 'エクスポート先を選択',
	conversationMessengerClassicImportDemoAccountShort: 'あなたのアカウント',
	conversationMessengerClassicImportDemoProfileName: 'あなたのアカウント名',
	conversationMessengerClassicImportDemoProfiles: 'プロフィール',
	conversationMessengerClassicImportDemoChooseProfile: 'プロフィールを選択',
	conversationMessengerClassicImportDemoPastActivity: '過去のアクティビティ',
	conversationMessengerClassicImportDemoCurrentActivity: '進行中のアクティビティ',
	conversationMessengerClassicImportDemoCreateExport: 'エクスポートを作成',
	conversationMessengerClassicImportDemoExportIntro: '端末にダウンロードする情報のコピーを作成します。',
	conversationMessengerClassicImportDemoExportTitle: '情報をエクスポート',
	conversationMessengerClassicImportDemoCaptionDrop: '準備できたら.zipをダウンロードし、下へアップロード',
	conversationMessengerClassicImportDemoCaptionStart: 'エクスポートを開始をタップ',
	conversationMessengerClassicImportDemoCaptionJson: 'JSON形式を選び、保存',
	conversationMessengerClassicImportDemoCaptionMessages: 'コツ：すべてクリア後、メッセージのみ（より早い）',
	conversationMessengerClassicImportDemoCaptionDevice: '端末にエクスポートをタップ',
	conversationMessengerClassicImportDemoCaptionCreate: 'エクスポートを作成をタップ',
	conversationMessengerClassicImportDemoActivitySection: 'Facebookのアクティビティ',
	conversationMessengerClassicImportDemoProfileAccount: 'あなたのアカウント · Facebook',
	conversationMessengerClassicImportDemoPlatform: 'Facebook',
	conversationMessengerClassicImportDemoCaptionProfile: 'Facebookプロフィールを選択',
	conversationMessengerClassicImportDemoTitle: '2023年以前のMessengerの会話をエクスポート',
	conversationMessengerEncryptedImportDemoTitle: '2023年以降のMessengerのチャットをエクスポート',
	conversationImportDemoBadgeMeta: '例：上のボタンから、Metaで同じ操作をします',
	conversationMessengerEncryptedImportDemoBadge: '例：上のボタンから、Messenger.comで同じ操作をします',
	conversationMessengerEncryptedImportDemoCaptionLogin: 'パソコンでMessenger.comを開き、ログインします',
	conversationMessengerEncryptedImportDemoCaptionSettings: '左下の歯車アイコンをクリックします',
	conversationMessengerEncryptedImportDemoCaptionPrivacy: '「プライバシーとセキュリティ」を開きます',
	conversationMessengerEncryptedImportDemoCaptionEncrypted: '「エンドツーエンド暗号化チャット」を選びます',
	conversationMessengerEncryptedImportDemoCaptionStorage: '「メッセージの保存」を開きます',
	conversationMessengerEncryptedImportDemoCaptionDownloadData: '「メッセージの保存データをダウンロード」をクリックします',
	conversationMessengerEncryptedImportDemoCaptionRange: 'Mediaのチェックは外さず、期間はAll timeを選びます',
	conversationMessengerEncryptedImportDemoCaptionDrop: '「ファイルをダウンロード」をクリックし、.zipを下に置きます',
	conversationMessengerEncryptedImportDemoLandingTitle: '楽しい会話のための場所',
	conversationMessengerEncryptedImportDemoLandingText: 'Messengerなら大切な人とつながり続けられます。',
	conversationMessengerEncryptedImportDemoContinueAs: 'あなたの名前として続行',
	conversationMessengerEncryptedImportDemoSwitchAccount: 'アカウントを切り替える',
	conversationMessengerEncryptedImportDemoChats: 'チャット',
	conversationMessengerEncryptedImportDemoSearch: 'Messengerを検索',
	conversationMessengerEncryptedImportDemoContactName: 'あなたの連絡先',
	conversationMessengerEncryptedImportDemoContactStatus: 'オンライン',
	conversationMessengerEncryptedImportDemoLockBadge: 'エンドツーエンド暗号化',
	conversationMessengerEncryptedImportDemoMenuPreferences: '設定',
	conversationMessengerEncryptedImportDemoMenuProfileName: 'プロフィール名を編集',
	conversationMessengerEncryptedImportDemoMenuRestricted: '制限中のアカウント',
	conversationMessengerEncryptedImportDemoMenuAccessibility: 'アクセシビリティ',
	conversationMessengerEncryptedImportDemoMenuHelp: 'ヘルプ',
	conversationMessengerEncryptedImportDemoPrivacyTitle: 'プライバシーとセキュリティ',
	conversationMessengerEncryptedImportDemoPrivacyReceipts: '既読確認',
	conversationMessengerEncryptedImportDemoPrivacyReported: '報告したチャット',
	conversationMessengerEncryptedImportDemoPrivacyKeys: 'チャットの鍵を確認',
	conversationMessengerEncryptedImportDemoEncryptedTitle: 'エンドツーエンド暗号化チャット',
	conversationMessengerEncryptedImportDemoEncryptedHint: 'エンドツーエンド暗号化チャットの設定を管理します',
	conversationMessengerEncryptedImportDemoEncryptedAlerts: 'セキュリティ通知',
	conversationMessengerEncryptedImportDemoEncryptedPreviews: 'プレビュー',
	conversationMessengerEncryptedImportDemoStorageTitle: 'メッセージの保存',
	conversationMessengerEncryptedImportDemoStorageHint: 'チャット履歴の保存方法とアクセス方法を管理します',
	conversationMessengerEncryptedImportDemoStorageIntro: 'エンドツーエンド暗号化されたメッセージはバックアップに安全に保存されています。',
	conversationMessengerEncryptedImportDemoStoragePin: 'PINコードをリセット',
	conversationMessengerEncryptedImportDemoStorageMethods: 'セキュリティ方法を管理',
	conversationMessengerEncryptedImportDemoStorageRemember: 'このブラウザを記憶する',
	conversationMessengerEncryptedImportDemoStorageDownload: 'メッセージの保存データをダウンロード',
	conversationMessengerEncryptedImportDemoStorageDownloadHint: 'エンドツーエンド暗号化されたすべてのメッセージと添付ファイルをダウンロードします。',
	conversationMessengerEncryptedImportDemoStorageAutoImport: '自動インポートを無効にする',
	conversationMessengerEncryptedImportDemoDownloadTitle: 'データをダウンロード',
	conversationMessengerEncryptedImportDemoDownloadIntro: 'エンドツーエンド暗号化されたすべてのメッセージと添付ファイルのコピーは、いつでもダウンロードできます。',
	conversationMessengerEncryptedImportDemoMediaTip: 'Mediaのチェックを外さないでください。外すと本に写真が入りません。',
	conversationMessengerEncryptedImportDemoFileNotice: 'ファイルの準備には数分かかることがあります。',
	conversationMessengerEncryptedImportDemoDownloadFile: 'ファイルをダウンロード',
	conversationMessengerEncryptedImportDemoReadyHint: '.zipは開かずにそのまま下に置いてください。会話はそのあとで選びます。',
	conversationMessengerImportEncryptedCta: 'Messenger.comを開いてエクスポート',
	conversationMessengerImportClassicStep1: '<b>エクスポートを作成</b>をタップし、<b>Facebook</b>プロフィールを選び、<b>端末にエクスポート</b>を選びます。',
	conversationMessengerImportClassicStep2: '早くするコツ：<b>すべてクリア</b>して<b>メッセージ</b>だけにチェック。<b>JSON</b>形式と<b>低</b>画質を選びます。',
	conversationMessengerImportClassicStep3: '<b>エクスポートを開始</b>をタップし、メールを待ち（10分〜24時間）、<b>.zip</b>を<b>開かずに</b>下へアップロード。会話は<b>その後</b>に選びます。',
	conversationMessengerImportClassicAlert: '会話が見つかりませんか？<b>2023年以降</b>に切り替えてください。<b>JSON</b>形式が必須です（HTML不可）。コツ：<b>メッセージ</b>だけにすると早いですが、必須ではありません。',
	conversationMessengerImportEncryptedStep1: 'パソコンで<b>Messenger.com</b>を開いてログインし、左下の<b>歯車アイコン</b>をクリックします。',
	conversationMessengerImportEncryptedStep2: '<b>プライバシーとセキュリティ</b>、<b>エンドツーエンド暗号化チャット</b>、<b>メッセージの保存</b>と進みます。',
	conversationMessengerImportEncryptedStep3: '<b>メッセージの保存データをダウンロード</b>をクリックします。<b>Media</b>のチェックは外さず、期間は<b>All time</b>を選びます。',
	conversationMessengerImportEncryptedStep4: '<b>ファイルをダウンロード</b>をクリックし、<b>.zip</b>を<b>開かずに</b>下に置いてください。会話は<b>アップロード後</b>に選びます。',
	conversationMessengerImportEncryptedAlert: '<b>Media</b>のチェックを外さないでください。外すと本に写真が入りません。会話が見つからない場合は<b>2023年以前</b>に切り替えてください。',
	conversationMessengerImportClassicDetailTitle: '2023年以前のエクスポート：詳しい手順',
	conversationMessengerImportClassicDetailIntro: '下のスクリーンショットに従ってください。上のボタンでエクスポートページを直接開けます。',
	conversationMessengerImportClassicDetailSkipApp: 'ボタンでページを開きました：ステップ5から始める',
	conversationMessengerImportClassicDetailStep1: '<b>Messenger</b>アプリを開き、三点メニューから<b>設定</b>に進んでください。',
	conversationMessengerImportClassicDetailStep2: '<b>歯車</b>アイコンをタップしてください。',
	conversationMessengerImportClassicDetailStep3: '<b>アカウントセンター</b>を選んでください。',
	conversationMessengerImportClassicDetailStep4: '<b>あなたの情報とアクセス許可</b>をタップしてください。',
	conversationMessengerImportClassicDetailStep5: '<b>あなたの情報をダウンロード</b>を選んでください。',
	conversationMessengerImportClassicDetailStep6: '<b>情報をダウンロードまたは転送</b>に進んでください。上のボタンを使った場合は、すでにこのページが表示されています。',
	conversationMessengerImportClassicDetailStep7: '<b>Facebook</b>を選んでください。アカウントによってはこのステップが表示されないことがあります。',
	conversationMessengerImportClassicDetailStep8: '<b>一部の情報</b>を選んでください。',
	conversationMessengerImportClassicDetailStep9: '<b>メッセージ</b>だけにチェックを入れ、<b>次へ</b>をタップしてください。',
	conversationMessengerImportClassicDetailStep10: '<b>デバイスにダウンロード</b>をタップしてください。',
	conversationMessengerImportClassicDetailStep11: 'ご希望の期間、<b>JSON</b>形式、画質<b>低</b>を選んでください。アーカイブは<b>10分から24時間</b>で準備が整います：用意ができるとメールでお知らせします。',
	conversationMessengerImportClassicDetailStep12: '<b>.zip</b>ファイル全体を端末にダウンロードし、<b>開かずに</b>下にアップロードしてください。本に使われるのは、このあとお選びいただく会話だけです。',
	conversationMessengerImportEncryptedDetailTitle: '2023年以降のエクスポート：詳しい手順',
	conversationMessengerImportEncryptedDetailIntro: '以下のスクリーンショットを見ながら各ステップを進めてください。上のボタンからMessenger.comを開き、ステップ2へ進むこともできます。',
	conversationMessengerImportEncryptedDetailSkipApp: 'すでにMessenger.comを開いています：ステップ2から始める',
	conversationMessengerImportEncryptedDetailStep1: 'パソコンで<b>Messenger.com</b>を開き、左下のプロフィール写真をクリックしてください。',
	conversationMessengerImportEncryptedDetailStep2: '<b>プライバシーとセキュリティ</b>をクリックしてください。',
	conversationMessengerImportEncryptedDetailStep3: '<b>エンドツーエンド暗号化されたチャット</b>をクリックしてください。',
	conversationMessengerImportEncryptedDetailStep4: '<b>セキュアストレージ</b>をクリックしてください。',
	conversationMessengerImportEncryptedDetailStep5: '<b>セキュアストレージからデータをダウンロード</b>をクリックしてください。',
	conversationMessengerImportEncryptedDetailStep6: '<b>ファイルをダウンロード</b>をクリックしてください。',
	conversationMessengerImportEncryptedDetailStep7: 'Facebookのパスワードを入力し、<b>確認</b>をクリックしてください。',
	conversationMessengerImportEncryptedDetailStep8: '<b>ダウンロード</b>をクリックしてください。ファイルの準備には数分かかることがあります。',
	conversationMessengerImportEncryptedDetailStep9: '<b>.zip</b>ファイル全体をパソコンにダウンロードし、<b>開かずに</b>下にアップロードしてください。本に使われるのは、このあとお選びいただく会話だけです。',
	conversationMessengerImportMissingTip: 'リストに会話がありませんか？戻って<b>2023年以降</b>のエクスポートを試してください。',
	conversationMessengerImportEmptyTitle: 'このアーカイブに会話が見つかりません',
	conversationSmsImportTagline: 'ここにアップロードするファイルはありません：すべて専用ソフトまたは専用アプリから行います。',
	conversationSmsImportIntro: 'このページではファイルのアップロードは不要です。すべて専用ソフト（iPhone）または専用アプリ（Android）から行います。ご利用の環境を選んでください：',
	conversationSmsImportContext: 'Android用アプリは<b>Google Playでは配信していません</b>。ストアではSMSへのアクセスが制限されています。アプリを開く前に、AndroidとPlay プロテクトが確認を求めます。',
	conversationSmsImportPlatformIphoneMac: 'iPhone + Mac',
	conversationSmsImportPlatformIphonePc: 'iPhone + PC',
	conversationSmsImportPlatformAndroid: 'Android',
	conversationSmsImportMacCta: 'Mac用ソフトをダウンロード',
	conversationSmsImportPcCta: 'PC用ソフトをダウンロード',
	conversationSmsImportAndroidCta: 'Android用アプリをダウンロード',
	conversationSmsImportMacStep1: 'Mac用ソフトをダウンロードしてください。',
	conversationSmsImportMacStep2: 'インストールして、<b>画面の案内に従ってください</b>。',
	conversationSmsImportMacStep3: 'アカウントに送る<b>会話</b>を選び、転送が終わるまで画面を開いたままにしてください。',
	conversationSmsImportMacStep4: '下のソフトをインストールし、システム設定 → プライバシーで<b>フルディスクアクセス</b>を許可してから、アカウントに送る会話を選んでください。',
	conversationSmsImportMacHelp: 'ソフトがバックアップを見つけられない場合：システム設定 → プライバシーとセキュリティ → <b>フルディスクアクセス</b> → MonLivreSMSを追加してください（先に左下の鍵アイコンを解除します）。',
	conversationSmsImportMacAlert: 'ここではファイルをアップロードしません：転送はソフトから始まり、画面の案内に従って進みます。',
	conversationSmsImportPcStep1: 'PC用ソフトをダウンロードしてください。',
	conversationSmsImportPcHelp: 'iTunesで<b>今すぐバックアップ</b>をクリックする前に、<b>ローカルバックアップを暗号化</b>のチェックが外れていることを確認してください。上の画像が目印です。',
	conversationSmsImportHelpToggle: 'もっと詳しい説明が必要ですか？',
	conversationSmsImportPcStep2: 'インストールして、<b>画面の案内に従ってください</b>。',
	conversationSmsImportPcStep3: 'アカウントに送る<b>会話</b>を選び、転送が終わるまで画面を開いたままにしてください。',
	conversationSmsImportPcStep4: '下のソフトをインストールして起動し（Windowsが確認を求めたら実行を許可してください）、アカウントに送る会話を選んでください。',
	conversationSmsImportPcAlert: 'ここではファイルをアップロードしません：転送はソフトから始まり、画面の案内に従って進みます。',
	conversationSmsImportAndroidStep1: 'Android端末で、下の<b>ストア外アプリ</b>をダウンロードしてください：Google PlayではSMSへのアクセスが許可されていません。',
	conversationSmsImportAndroidStep2: 'ダウンロードしたファイルを開きます。インストールが許可されない場合は、<b>設定</b>をタップし、<b>この提供元のアプリを許可</b>をオンにして戻ります。',
	conversationSmsImportAndroidStep3: '<b>Play プロテクト</b>が表示されたら、<b>詳細</b>をタップし、次に<b>インストールを続行</b>をタップします。その後<b>インストール</b>、<b>開く</b>の順にタップしてください。',
	conversationSmsImportAndroidStep4: 'アプリで<b>SMS</b>と<b>連絡先</b>へのアクセスを許可してください。',
	conversationSmsImportAndroidStep5: '<b>会話</b>を選んで確定します。転送が終わるまで画面を閉じないでください。メッセージはアカウントへ直接送られます。',
	conversationSmsImportAndroidAlert: 'ここにアップロードするファイルはありません。写真をすべて取り込むため、アプリの転送画面を開いたままにしてください。',
	conversationSmsImportFooter: '転送が終わったら、このサイトで本をカスタマイズしてください：アプリから自動的にこのページへ移動します。',
	conversationSmsImportAndroidDetailIntro: 'Android端末で各ステップを進めてください。アプリは<b>Google Playでは配信していません</b>。開く前にAndroid、続いてPlay プロテクトが確認を求めます。通常の手順です。',
	conversationSmsImportAndroidDetailSkipApp: 'アプリはすでにダウンロード済みです：ステップ2から始める',
	conversationSmsImportAndroidDetailStep1: 'SMSエクスポート用アプリをGoogle Play以外からダウンロードしてください（下のボタン）：Google PlayではSMSへのアクセスが許可されていません。',
	conversationSmsImportAndroidDetailStep2: 'ダウンロード後、<b>開く</b>をタップしてください。',
	conversationSmsImportAndroidDetailStep3: '<b>設定</b>をタップしてインストールを許可してください。',
	conversationSmsImportAndroidDetailStep4: '<b>この提供元のアプリを許可</b>をオンにして、インストール画面に戻ります。',
	conversationSmsImportAndroidDetailStep5: '<b>Play プロテクト</b>が表示されたら、<b>詳細</b>をタップし、<b>インストールを続行</b>をタップします。インストールしてアプリを開き、SMSと連絡先へのアクセスを許可してください。',
	conversationSmsImportAndroidDetailStep6: 'お好きな<b>会話</b>を選んでください。',
	conversationSmsImportAndroidDetailStep7: '内容を確認して確定してください：写真をすべて取り込むため、転送が終わるまで転送画面を開いたままにしてください。転送後は、本のカスタマイズ画面へ自動的に移動します。',
	conversationSmsImportAndroidDetailTitle: 'AndroidのSMSエクスポート：詳しい手順',
	conversationSmsImportMacDetailIntro: 'ソフトをダウンロードして、画面の案内に従ってください。下のスクリーンショットは主にインストールの参考です。',
	conversationSmsImportMacDetailSkipSoftware: 'ソフトはすでにダウンロード済みです：ステップ8から始める',
	conversationSmsImportMacDetailStep1: 'iPhoneをUSBケーブルでMacに接続してください。',
	conversationSmsImportMacDetailStep10: '<b>システム設定</b> → <b>プライバシーとセキュリティ</b>を開いてください。',
	conversationSmsImportMacDetailStep11: 'ページの一番下までスクロールし、<b>このまま開く</b>をクリックしてください。',
	conversationSmsImportMacDetailStep12: 'セキュリティの警告が表示されたら<b>許可</b>をクリックしてください。',
	conversationSmsImportMacDetailStep13: '<b>開く</b>をクリックしてください。',
	conversationSmsImportMacDetailStep14: '<b>続ける</b>をクリックしてください。',
	conversationSmsImportMacDetailStep15: 'もう一度<b>続ける</b>をクリックしてください。',
	conversationSmsImportMacDetailStep16: '<b>インストール</b>をクリックしてください。',
	conversationSmsImportMacDetailStep17: 'セキュリティの警告が表示されたら、もう一度<b>許可</b>をクリックしてください。',
	conversationSmsImportMacDetailStep18: '<b>閉じる</b>をクリックしてインストーラーを終了してください。',
	conversationSmsImportMacDetailStep19: '<b>Finder</b> → <b>アプリケーション</b>を開き、<b>MonLivreSMS</b>を起動してください。',
	conversationSmsImportMacDetailStep2: '写真入りの本にする場合：<b>メッセージ</b>アプリを開いて会話を選び、<b>連絡先名</b>をタップしてください。',
	conversationSmsImportMacDetailStep20: '左上の<b>Appleメニュー</b> → <b>システム設定</b>をクリックしてください。',
	conversationSmsImportMacDetailStep21: '<b>プライバシーとセキュリティ</b> → <b>フルディスクアクセス</b>を開いてください。',
	conversationSmsImportMacDetailStep22: 'MonLivreSMSのアイコンをクリックしたままリストにドラッグし、<b>フルディスクアクセス</b>にチェックを入れてください。',
	conversationSmsImportMacDetailStep23: '<b>開く</b>をクリックして確定してください。',
	conversationSmsImportMacDetailStep24: '2回目の確認が表示されたら、もう一度<b>開く</b>をクリックしてください。',
	conversationSmsImportMacDetailStep25: 'エクスポートする<b>会話</b>を選んでください：メッセージと写真がアカウントに送信されます。インターネット接続が安定した状態で、転送が終わるまで転送画面を開いたままにしてください。',
	conversationSmsImportMacDetailStep3: '連絡先の詳細画面を一番下までスクロールしてください。',
	conversationSmsImportMacDetailStep4: '<b>ダウンロード</b>をタップして、iCloudの写真をすべてiPhoneに取り込んでください。',
	conversationSmsImportMacDetailStep5: '<b>Finder</b>を開き、サイドバーでiPhoneを選び、<b>ローカルバックアップを暗号化</b>のチェックを外して、<b>iPhone内のすべてのデータをこのMacにバックアップ</b>を有効にしてください。',
	conversationSmsImportMacDetailStep6: '<b>今すぐバックアップ</b>をクリックし、バックアップが終わるまでお待ちください。',
	conversationSmsImportMacDetailStep7: 'Mac用のMonLivreSMSソフトをダウンロードしてください（このページの下にあるボタン）。',
	conversationSmsImportMacDetailStep8: 'ダウンロードした<b>MonLivreSMS</b>フォルダをダブルクリックしてください。',
	conversationSmsImportMacDetailStep9: '<b>OK</b>をクリックしてインストールを開始してください。',
	conversationSmsImportMacDetailTitle: 'iPhone + MacでのSMSエクスポート：詳しい手順',
	conversationSmsImportPcDetailIntro: 'ソフトをダウンロードして、画面の案内に従ってください。下のスクリーンショットは主にインストールの参考です。',
	conversationSmsImportPcDetailSkipSoftware: 'ソフトはすでにダウンロード済みです：ステップ3から始める',
	conversationSmsImportPcDetailStep1: 'iPhoneをUSBケーブルでPCに接続してください。',
	conversationSmsImportPcDetailStep2: 'PC用のMonLivreSMSソフトをダウンロードしてください（このページの下にあるボタン）。',
	conversationSmsImportPcDetailStep3: 'まだの場合は<link>iTunes</link>をインストールしてください。',
	conversationSmsImportPcDetailStep4: 'iTunesを起動してください。',
	conversationSmsImportPcDetailStep5: '<b>Apple ID</b>でサインインし、求められたらiPhoneで承認してください。',
	conversationSmsImportPcDetailStep6: 'iPhoneが認識されたら<b>続ける</b>をクリックしてください。',
	conversationSmsImportPcDetailStep7: '<b>概要</b>で<b>ローカルバックアップを暗号化</b>のチェックを外し、<b>今すぐバックアップ</b>をクリックしてください（iCloudではなく、このパソコンに保存します）。',
	conversationSmsImportPcDetailStep8: 'バックアップが終わったら、MonLivreSMSのフォルダを開いてください。Windowsに警告が表示された場合は、<b>詳細情報</b>をクリックしてから<b>実行</b>をクリックしてください。そのあと、アカウントに送る会話を選んでください。',
	conversationSmsImportPcDetailTitle: 'iPhone + PCでのSMSエクスポート：詳しい手順',
	offerErrorRequired: '必須項目をご入力ください。',
	offerErrorEmail: 'メールアドレスをご確認ください。',
	offerErrorGiftEmail: 'お贈り先のメールアドレスをご確認ください。',
	offerErrorGiftSameEmail: 'お贈り先には、ご自身とは別のメールアドレスをご入力ください。',
	offerErrorGeneric: '申し訳ございません、うまくいきませんでした。しばらくしてからもう一度お試しください。',
	offerStepWhoEyebrow: 'さっそく始めましょう',
	offerStepWhoTitle: '本はどなたが作りますか？',
	offerStepWhoHint: 'ご自身で作ります。自分用でも、贈るためでも。ギフトカードは、相手が本を作る場合です。',
	offerWhoSelf: '自分が作ります',
	offerWhoSelfHint: '自分用、または印刷してから贈る',
	offerWhoGift: 'ギフトカードを贈ります',
	offerWhoGiftHint: '相手がリンクを受け取り、自分で本を作ります',
	offerStepOccasionEyebrow: 'どんなとき',
	offerStepOccasionHint: '思い浮かべている、そのとき。',
	offerStepGiftEyebrow: 'プレゼント',
	offerStepGiftTitle: 'どなたへ贈りますか？',
	offerStepGiftHint: 'プレゼントは、本を作成するためのリンクを添えてメールでお届けします。印刷もラッピングも必要ありません。',
	offerGiftName: 'お贈り先のお名前',
	offerGiftEmail: 'お贈り先のメールアドレス',
	offerGiftEmailHelp: 'お支払い完了後すぐに、このアドレスへプレゼントが届きます。',
	offerGiftFromName: 'ご自身のお名前',
	offerGiftFromNameHelp: 'どなたからの贈り物か、お相手に伝わります。',
	offerGiftMessage: 'ひとことメッセージ（任意）',
	offerGiftMessagePlaceholder: 'このメッセージが、いつもあなたのそばにありますように。',
	offerContinue: '次へ',
	offerStepMessengerEyebrow: 'メッセージ',
	offerStepMessengerTitleGift: '{name}さんの本になるメッセージは、どのアプリにありますか？',
	offerStepMessengerTitle: '大切なメッセージは、どのアプリにありますか？',
	offerStepMessengerHint: 'ひとつお選びください。あとから変更することもできます。',
	offerStepMessengerHintGift: 'あなたと{name}さんの会話でも、{name}さんと大切な方との会話でもかまいません。アプリに迷ったら、{name}さんがあとから別のアプリを選べます。',
	offerStepEmailEyebrow: 'あと少しです',
	offerStepEmailTitle: 'アカウント',
	offerStepEmailHintGift: 'Google、Apple、またはメール。確認メールのあと、ギフトカードを支払います。',
	offerStepEmailHint: 'Google、Apple、またはメール。確認メールのあと、会話を取り込みます。',
	offerStepEmailHintPay: 'Google、Apple、またはメール。確認メールのあと、本をお支払いいただきます。',
	offerEmailLabel: 'メールアドレス',
	offerEmailPlaceholder: 'name@example.jp',
	offerEmailSubmit: 'お支払いへ進む',
	offerEmailSubmitAccount: 'アカウントを作成',
	offerEmailPrivacy: '本のご案内だけです。迷惑メールフォルダもご確認ください。',
	offerStepSentEyebrow: 'おかえりなさいませ',
	offerStepSentTitle: 'すでにアカウントをお持ちです',
	offerStepSentCodeHint: '{email} 宛てに6桁のコードをお送りしました。こちらに入力してください。ご注文はお支払いいただける状態でお待ちしています。迷惑メールフォルダもご確認ください。',
	offerStepSentCodeHintAccount: '{email} 宛てに6桁のコードをお送りしました。こちらに入力すると、アカウントが開いて本づくりを始められます。迷惑メールフォルダもご確認ください。',
	offerStepPayEyebrow: '最後のステップ',
	offerStepPayTitleGift: '{name}さんへの本',
	offerStepPayTitle: 'あなただけの紙の本',
	offerLoggedAs: '{email} でログイン中',
	offerSwitchAccount: 'ご本人ではありませんか？',
	offerTrustReviews: 'Trustpilotで{count}件以上のレビュー',
	offerTrustGuarantee: '返金保証',
	offerTrustShipping: '送料無料',
	offerPageTitle: 'メッセージを一冊の本に',
	offerBack: '戻る',
	offerItemName: 'カスタマイズできる紙の本',
	offerPayBenefitBook: 'メッセージと写真をレイアウトした、あなただけの紙の本',
	offerPayBenefitBookGift: 'お好きなメッセージと写真で作る、本物の紙の本',
	offerPayBenefitMedia: '動画とボイスメッセージも、本に印刷されたQRコードからもう一度楽しめます',
	offerPayBenefitCustom: '表紙、写真、タイトル、色、まえがきまで、すべてカスタマイズできます',
	offerPayBenefitPdf: 'PDF版も無料でお付けします',
	offerPayBenefitShipping: '送料無料',
	offerPayTotal: '合計',
	offerPayNextGift: 'お支払い完了後すぐに、プレゼントのメールが{name}さんに届きます。',
	offerPayNextSelf: 'お支払いのあと、会話を取り込みます。数分で終わります。',
	offerPayDreamSelf: 'スマホで何度も読み返すあのメッセージが、もうすぐあなたの手の中に。いつまでも。',
	offerPayDreamGift: '{name}さんがこの本を開く日、たくさんのメッセージがその手の中でよみがえります。',
	offerPayButton: '{price}を支払う',
	offerPaySecure: '安全なお支払い。定期購入ではありません。',
	offerConfirmStepsTitle: 'ご利用の流れ',
	offerConfirmGiftStep1: '{name}さんがメールを開いてリンクをクリック',
	offerConfirmGiftStep2: '{name}さんが数分で会話をインポート',
	offerConfirmGiftStep3: '私たちが本を印刷してお届けします',
	offerConfirmGiftTitle: '{name}さんへお届けしました！',
	offerConfirmGiftLead: '{name}さん（{email}）へ、本を作成するリンクを添えてプレゼントをお届けしました。代金は送料込みでお支払い済みです。',
	offerConfirmViewOrder: 'ご注文内容を見る',
	offerConfirmGiftNote: '届いていない場合は、迷惑メールフォルダをご確認いただくよう、お相手にお伝えください。お気軽にお問い合わせいただくこともできます。',
	offerConfirmStep1: '{messenger}から会話をエクスポート',
	offerConfirmStep1Generic: 'メッセージアプリから会話をエクスポート',
	offerConfirmStep2: 'こちらにインポートするだけ。レイアウトはすべてお任せください',
	offerConfirmStep3: '内容をご確認いただければ、本を印刷してお届けします',
	offerConfirmTitle: 'お支払いが完了しました！',
	offerConfirmLead: 'あとは{messenger}の会話をインポートするだけです。手順に沿ってご案内しますので、数分で完了します。',
	offerConfirmLeadGeneric: 'あとは会話をインポートするだけです。手順に沿ってご案内しますので、数分で完了します。',
	offerConfirmCta: '{messenger}の会話をインポートする',
	offerConfirmCtaGeneric: '会話をインポートする',
	offerConfirmChangeMessenger: 'メッセージは別のアプリにあります',
	offerConfirmEmailNote: '領収書とログイン用リンクを {email} 宛てにお送りしました。',
	userMagicTitle: 'ログイン',
	userMagicWorking: 'ログインしています…',
	userMagicExpired: 'このリンクは有効期限が切れています。ワンクリックで新しいリンクをお送りします。',
	userMagicInvalid: 'このリンクは無効になっています。ワンクリックで新しいリンクをお送りします。',
	userMagicSent: 'このアドレスのアカウントが存在する場合は、新しいリンクをお送りしました。迷惑メールフォルダもご確認ください。',
	userMagicEmailLabel: 'メールアドレス',
	userMagicSend: '新しいリンクを受け取る',
	conversationPreviewBookCreditRemaining: '+{price}',
	conversationPreviewIncluded: 'お支払い済み',
	conversationPreviewCollectionPrepaidNote: '{count}巻 · うち{paid}巻はお支払い済み',
	conversationPreviewBookCreditBannerBestof: '本の代金はお支払い済みです。Best Ofは追加料金なしでお作りいただけます。コンプリートコレクションをご希望の場合は、差額のみのお支払いとなります。',
	conversationPreviewBookCreditBanner: '本の代金は通常配送料込みでお支払い済みです。お好みに仕上げてから、ご注文を確定してください。',
	conversationOrderButtonBookCreditRemaining: '本を仕上げる · 残り{price}',
	conversationOrderButtonBookCreditIncluded: '本を仕上げる · お支払い済み',
	conversationPreviewBookCreditOrderHint: '{credit}はお支払い済み · 定価 {fullPrice}',
	conversationOrderButtonBookCredit: '本を仕上げる',
	conversationPreviewStickyBookCredit: '本の代金はお支払い済み',
	paymentMethodBookCreditHint: '本の代金はお支払い済みです',
	cartTotalsBookCredit: '本の代金（お支払い済み）',
	paymentMethodBookcredit: '前払い済みの本',
  },
};
